/**
 * Avast Module Definition
 * @version 1.1.0
 * @author Jiri Duchon <duchon@avast.com>
 * @copyright AVAST Software s.r.o.
 */

var avm = (function() {
	'use strict';
	var toString = Object.prototype.toString,
		modules = {};
	return {

		/**
		 * Define module
		 * @param {string} namespace
		 * @param {*} value
		 * @returns {*}
		 */
		define: function(namespace, value) {
			if (typeof namespace === 'string' && typeof value !== 'undefined') {
				var spaces = namespace.split('.'),
					spacesLength = spaces.length,
					spacesLast = spacesLength - 1,
					spacesRoot = modules,
					space;
				for (var i = 0; i < spacesLength; i++) {
					space = spaces[i];
					if (i < spacesLast && (toString.call(spacesRoot[space]) === '[object Object]' && spacesRoot[space] !== null || !(space in spacesRoot))) {
						spacesRoot = spacesRoot[space] = spacesRoot[space] || {};
					} else if (i === spacesLast && !(space in spacesRoot)) {
						spacesRoot = spacesRoot[space] = value;
					} else {
						throw new Error('Module ' + namespace + ' already exists');
					}
				}
				return spacesRoot;
			} else {
				throw new Error('Invalid method arguments');
			}
		},

		/**
		 * Require module
		 * @param {string} namespace
		 * @param {boolean} [required=true]
		 * @returns {*}
		 */
		require: function(namespace, required) {
			required = typeof required === 'undefined' ? true : required;
			if (typeof namespace === 'string' && typeof required === 'boolean') {
				var spaces = namespace.split('.'),
					spacesLength = spaces.length,
					spacesRoot = modules,
					space;
				for (var i = 0; i < spacesLength; i++) {
					space = spaces[i];
					if (toString.call(spacesRoot) === '[object Object]' && spacesRoot !== null && space in spacesRoot) {
						spacesRoot = spacesRoot[space];
					} else if (required) {
						throw new Error('Module ' + namespace + ' does not exist');
					} else {
						if (typeof console === 'object' && typeof console.warn === 'function') {
							console.warn('Module ' + namespace + ' does not exist');
						}
						return;
					}
				}
				return spacesRoot;
			} else {
				throw new Error('Invalid method arguments');
			}
		}
	};
})();

/**
 * Init cash
 */
(function() {
	if (typeof avm === 'object' && typeof avm.define === 'function' && typeof window.cash === 'function') {
		avm.define('jquery', window.cash); //Replace jQuery with cash. Remove when migration done
		avm.define('cash', window.cash);
	}
})();

/**
 * Append p_bld param to cart links
 * @version 0.2.0
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.appendPbld
 * @requires jquery
 */
avm.define('avast.web.appendPbld', (function () {
    'use strict';

    var $ = avm.require('jquery');

    return {
        once: 0,
        init: function(){
            var appendPbld = this;
            var re = '[\\?&](p_bld=[^&#]*)';
            var regex = new RegExp(re, 'i');
            var results = regex.exec(window.location.href);
            var param = '';

            if(results){
                // Web
                $('a').each(function() {
                    if (this.href.indexOf('store.avast.com') != -1 && this.href.indexOf('p_bld=') == -1) {
                        param =  (this.href.indexOf('?') > -1) ? '&' + results[1] : '?' + results[1];
                        this.href += param;
                    }
                });
                // Ints
                $('.choice', '.selection').each(function() {
                    var input = $(this).find('input[type=radio]');
                    var cartLink = input.val();
                    if (cartLink.indexOf('store.avast.com') != -1 && cartLink.indexOf('p_bld=') == -1) {
                        param =  (cartLink.indexOf('?') > -1) ? '&' + results[1] : '?' + results[1];
                        input.val(cartLink + param);
                    }
                });
            }

            if (!this.once) {
                $(document).on('avast.ab.updatePrice avast.bab.updatePrice', function() {appendPbld.init();});
                this.once = 1;
            }
        }
    };
})());

// unsupported chrome on older windows versions GLOWEB-7000


(function() {
    'use strict';

    try {
        var version = avastGlobals.detect.os.version;

        // check for windows version 7, 8, 8.1
        if(avastGlobals.detect.os.isWindows && (version === '7' || version === '8' || version === '8.1')) {
            var buttons = document.querySelectorAll('[data-download-name*="ASB"]');

            // set tooltip on all download links contains ASB download ID
            buttons.forEach(function(button) {
                setTooltipOnButton(button);
            });

            // event listener for change in actionbox and search if in updated content isn't link with ASB download ID
            window.addEventListener('actionbox-updated', function(e) {
                e.detail.element.querySelectorAll('[data-download-name*="ASB"]:not([data-toggle])').forEach(function(button) {
                    setTooltipOnButton(button);
                    new BSN.Tooltip(button);
                });
            });

            // event listener for opened modal and search if modal content contains not-updated link with ASB download ID
            window.addEventListener('modal-shown', function(e) {
                e.detail.element.querySelectorAll('[data-download-name*="ASB"]:not([data-toggle])').forEach(function(button) {
                    setTooltipOnButton(button);
                    new BSN.Tooltip(button);
                });
            });

            // set tooltip with information about unsupported system version on provided button
            function setTooltipOnButton(button) {
                button.setAttribute('data-toggle', 'tooltip');
                button.title = avastGlobals.texts.chromeUnsupportedOS;
            }

        }

    } catch (error) {
        console.error(error);
        sdl.push({
            system: {
                error: {
                    type: error.name,
                    message: error.message,
                }
            },
            event: 'system.error'
        })
    }

})();


/**
 * Create SOURCE cookie from ref=cj, ref=td query string parameter
 * @version 0.2.0
 * @author Ales Gabriel, Michal Samaš
 * @module avast.web.cj
 * @todo use avast.storage modules for cookie
 * @copyright Avast Software s.r.o &copy;2015
 */

avm.define('avast.web.cj', (function() {
    var cj = {
        init: function(){
            var cj = this;
            var param = cj.getURLParameter('ref');
            var ref = (typeof param === 'string') ? param.toUpperCase() : null;
            var cjCookieName = 'SOURCE';
            var age = 7776000; // 90 days to expire
            var domain = '.avast.com';
            var path = '/';

			if (ref === 'CJ' || ref === 'TD') {
                cj.setCookie(cjCookieName, ref, domain, path, age);
            }
        },
        getURLParameter: function(name) {
            return decodeURI((RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||[,null])[1]);
        },
        setCookie: function(name,value,domain,path,age) {
            var exp = "",p = ";path=/",d = "";
            var val = (value) ? encodeURIComponent(value) : '';
            if (age) {
                d = new Date();
                d.setTime(d.getTime()+(age*1000));
                exp = ";expires="+d.toUTCString()+";max-age="+ age;
            }
            if(path){
                p = ";path="+path;
            }
            if(domain){
                d = ";domain="+domain;
            }

            document.cookie = name+"="+val+exp+d+p+";";
        }
    };

return cj;

})());

/**
* Avast Email capture form
* @version 1.0.0
* @author Jaroslav Slaby, Fedor Kuss
*/

(function(){
	// check if browser support fetch function
	if (document.querySelector('.e-capture')) {
		if (typeof fetch === 'function') {
			var selectorButton = document.querySelector('.e-capture');
			// set event listener on email capture button
			selectorButton.addEventListener('click', function() {
				loadEmailForm();
			})
		} else {
			// hide email capture button (for IE R.I.P)
			document.querySelector('.e-capture').classList.add('d-none');
		}
	}
})();

function loadEmailForm(captchaText) {
	var locale = '/' + avastGlobals.web.locale;

	// update locale on region with diferent 1. domain
	switch (avastGlobals.web.locale) {
		case 'en-ww':
			locale = '';
			break;

		case 'ja-jp':
			locale = '';
			break;

		case 'ru-ru':
			locale = '';
			break;

		case 'uk-ua':
			locale = '';
			break;

		default:
			break;
	}

	// fetch content of email capture form from CMS
	fetch('https://' + avastGlobals.web.domain + locale + '/email-capture-form-content', {headers: {
		'Accept': 'application/json',
		  'X-Requested-With': 'XMLHttpRequest'
	}}).then(function (response) {
		return response.text();
	}).then(function (html) {
		// get modal window body
		var	formModal = document.querySelector('#email-capture .modal-body');

		// assign response from fetch into modal
		formModal.innerHTML = html;

		// hide thank message (message after submiting)
		formModal.querySelector('#thank-page').classList.add('d-none');
		// hide error note of too many request from the same pc
		formModal.querySelector('#session-note').classList.add('d-none');
		// captcha
		if (formModal.querySelector('#frm-captcha')) {
			formModal.querySelector('#frm-captcha').setAttribute('placeholder', formModal.querySelector('#form-body').getAttribute('data-code'));
		}
		if (captchaText !== undefined) {
			formModal.querySelector('#frm-captcha').setAttribute('message', captchaText);
		}
		// run avast form linear/form fetch script
		initAvastForm();
	}).catch(function (err) {
		// There was an error

		// show error note
		if(/captcha/.test(err)) {
			document.querySelector('#email-capture #form-body').classList.add('d-none')
			document.querySelector('#email-capture #thank-page').classList.add('d-none')
			document.querySelector('#email-capture #session-note').classList.remove('d-none')
		}
	});
}

// function called by response from CMS ??
function submitForm(data) {

	// BE returns passed email -> show thank you
	if(data.email){
		document.querySelector('#email-capture #form-body').classList.add('d-none')
		document.querySelector('#email-capture #thank-page').classList.remove('d-none')
		document.querySelector('#email-capture #session-note').classList.add('d-none')
		$('#email-placeholder').html(data.email);
	}

	// BE returns error
	if(data.errors){
		// errror contains captcha
		if(data.errors.captcha) {
			// reload form with captcha field
			loadEmailForm(data.errors.captcha);
		} else {
			// show erro note
			document.querySelector('#email-capture #form-body').classList.add('d-none')
			document.querySelector('#email-capture #thank-page').classList.add('d-none')
			document.querySelector('#email-capture #session-note').classList.remove('d-none')
		}
	}
}


/**
 * Event emitter
 * @version 1.0.0
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.event.emitter
 * @return {Function}  Emitter constructor
 */
avm.define('avast.event.emitter', (function(){
	'use strict';

	/**
	 * Event emitter
	 * @version 1.2.1
	 * @see {@link https://github.com/component/emitter}
	 */

	/*
	(The MIT License)

	Copyright (c) 2014 Component contributors <dev@component.io>

	Permission is hereby granted, free of charge, to any person
	obtaining a copy of this software and associated documentation
	files (the "Software"), to deal in the Software without
	restriction, including without limitation the rights to use,
	copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the
	Software is furnished to do so, subject to the following
	conditions:

	The above copyright notice and this permission notice shall be
	included in all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	OTHER DEALINGS IN THE SOFTWARE.
	*/

	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */

	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};

	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */

	function mixin(obj) {
	  for (var key in Emitter.prototype) {
		obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}

	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
		.push(fn);
	  return this;
	};

	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.once = function(event, fn){
	  function on() {
		this.off(event, on);
		fn.apply(this, arguments);
	  }

	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};

	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};

	  // all
	  if (0 == arguments.length) {
		this._callbacks = {};
		return this;
	  }

	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;

	  // remove all handlers
	  if (1 == arguments.length) {
		delete this._callbacks['$' + event];
		return this;
	  }

	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
		cb = callbacks[i];
		if (cb === fn || cb.fn === fn) {
		  callbacks.splice(i, 1);
		  break;
		}
	  }
	  return this;
	};

	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */

	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
		, callbacks = this._callbacks['$' + event];

	  if (callbacks) {
		callbacks = callbacks.slice(0);
		for (var i = 0, len = callbacks.length; i < len; ++i) {
		  callbacks[i].apply(this, args);
		}
	  }

	  return this;
	};

	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */

	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};

	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */

	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};

	return Emitter;
})());

/**
 * Footer
 * @version 1.0.0
 * @author Jaroslav Slaby <jaroslav.slaby@avast.com>
 */
(function(){
	'use strict';

	// get footer element and lists control elements
	var footer = document.querySelector('[data-cmp-name="footer-links"]'),
		footerListControls = document.querySelectorAll('.js-footer-links'),
		first = true; // first run 

	// check if elements exists
	if (footer && footerListControls.length>0) {
		// check width on page load
		checkWidth(document.documentElement.clientWidth);

		// set listener on page resize and check width
		window.addEventListener("resize", function() {
			checkWidth(document.documentElement.clientWidth)
		});

		// set view between desktop and mobile (will be changed based on CSS pseudoelements)
		function checkWidth(width) {
			// mobile view
			if (width<992 && !footer.classList.contains('js-colapse')) {
				// set class on footer to avoid running this if if it is not needed
				footer.classList.add('js-colapse');

				// at the first run, create event listener for click on lists control elements
				if (first) {
					first = false;

					footerListControls.forEach(function(trigger) {
						trigger.addEventListener('click', function(e) {
							// after click toggle class on control elements
							this.classList.toggle('expand-list');
						})
					});
				}
			// desktop view
			} else if (width>=992 && footer.classList.contains('js-colapse')) {
				//remove class on footer
				footer.classList.remove('js-colapse');
			}
		}
	}
})();

/**
 * Avast Number format
 * @version 2.1.0
 * @author Michal Langhoffer <langhoffer@avast.com>
 * @module avast.number.format
 * @requires jquery
 */

avm.define('avast.number.format', (function () {
    'use strict';
    var $ = avm.require('jquery');
    return {
        options: {
            decimal: 0
        },
        translate: function (number, decimal) {
            var root = this,
                avastGlobals = window.avastGlobals;

            if (decimal !== undefined) {
                this.options.decimal = decimal;
            } else {
                this.options.decimal = 0;
            }
            if (!isNaN(number) && avastGlobals && typeof avastGlobals.web === 'object') {
                var ds = avastGlobals.web.numberDecimalSeparator,
                    ts = avastGlobals.web.numberThousandSeparator;
                if (ds && ds) {
                    var val = $().number_format(
                        number,
                        {
                            numberOfDecimals: root.options.decimal,
                            decimalSeparator: ds,
                            thousandSeparator: ts,
                            symbol: ""
                        }
                    );
                    return val;
                } else {
                    return number;
                }
            } else {
                return number;
            }
        }
    };
})());
/**
 * Check if cookie support is enabled
 * @version 1.0.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.storage.isCookieEnabled
 */
avm.define('avast.storage.isCookieEnabled', (function() {
	'use strict';
	if (navigator.cookieEnabled) {
		return true;
	} else {
		var key = 'isCookieEnabled';
		document.cookie = key + '=1';
		if (document.cookie.indexOf(key + '=1') !== -1) {
			document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT';
			return true;
		} else {
			return false;
		}
	}
})());

/**
 * Check if storage support is enabled
 * @version 1.1.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.storage.isStorageEnabled
 */
avm.define('avast.storage.isStorageEnabled', (function() {
	'use strict';
	try {
		if (typeof sessionStorage === 'object' && sessionStorage && typeof localStorage === 'object' && localStorage) {
			var key = 'isStorageEnabled';
			sessionStorage.setItem(key, '1');
			sessionStorage.removeItem(key);
			localStorage.setItem(key, '1');
			localStorage.removeItem(key);
			return true;
		}
	} catch (error) {
		if (typeof console === 'object' && console && typeof console.warn === 'function') {
			console.warn(error);
		}
	}
	return false;
})());

/**
* Avast Language selector
* @version 3
* @author Michal Langhoffer, Ales Gabriel, Jaroslav Slaby, Cenek Hybler
* @module avast.web.languageSelector
* @requires cash
*/
/* 
avm.define('avast.web.languageSelector', function () {
	'use strict';
	console.log("TEST");

	var $ = avm.require('cash'),
		regionModal = document.querySelector('.region-selector'), // modal with regions
		langSelectorBtn = document.querySelectorAll('.js-language-selector-trigger'), // button to open modal (in header and footer)
		subcategoryToggler = regionModal.querySelector('.js-subcategory'), // collapse toggler on mobile
		closeBtn = regionModal.querySelector('.region-selector-close'), // modal closing icon

		languageSelector = {
			init: function() {
				var self = this;
				// Highligh current region
				regionModal.find('.' + avast.locale).addClass('highlight');
				$(document).on('keydown.languageSelector.avast', self.keyPressHandler);
				langSelectorBtn.on('click', self.open);
				subcategoryToggler.on('click', self.toggleContinents);
				closeBtn.on('click', self.close);
			},
			keyPressHandler: function(evt) {
				if (evt.which === 27) {
					languageSelector.close(evt);
				}
			},
			open: function(e) {
				console.log("modal opened");
				regionModal.on('click', self.clickHandler);
				regionModal.addClass('active');
				$('body').addClass('js-language-selector-open');
			},
			close: function(e) {
				regionModal.off('click', self.clickHandler);
				regionModal.removeClass('active');
				$('body').removeClass('js-language-selector-open');
			},
			toggleContinents: function(e) {
				var $target =  $(e.currentTarget);
				$target.next().find('region').toggleClass('active');
				$target.next('.js-regions').toggleClass('hide-regions');
			}
		};

	return languageSelector;
}); */

/**
 * mqMarker module - Replace existing CSS class with new one. Classes prefix must match.
 * If called with specific `mqMarker` class in parameter, adds a class and removes existing on with the same dash-separated prefix.
 * Usefull for event delegation on desktop/mobile.
 * Only one marker per element is possible.
 * @module avast.web.mqMarker
 * @version 0.0.2
 * @author Ales Gabriel <gabriel@avast.com>
 * @param mqMarker {string} CSS class. Must have an unique prefix separated with "-".
 * @param selectors {String} Comma separated list of selectors
 * @returns els {Array} DOM elements
 */

avm.define('avast.web.mqMarker', function(mqMarker, selectors) {
	// Define selectors for elements which will be marked.
	var sels = selectors || 'body',
		prefixRe = /^.*?-/,
		mqMarkerPrefix = mqMarker.match(prefixRe),
		els = [],
		nList = document.querySelectorAll(sels),
		list = Array.prototype.slice.call(nList); // Support IE11

	if (typeof mqMarker !== 'string' && mqMarkerPrefix.length === 0) {
		//console.log('mqMarker prefix separated by "-" is missing: %s', mqMarker);
		return els;
	}

	list.forEach(function(el) {
		var cssClasses = el.classList;

		// console.log(cssClasses.length);
		// Reset all classes with the same prefix to prevent duplicit classes
		if (cssClasses.length && mqMarkerPrefix) {
			for (var i = 0; cssClasses.length > i; i++) {
				if (cssClasses[i].match(prefixRe)[0] === mqMarkerPrefix[0]) {
					// console.log('Removed class: %s', cssClasses[i]);
					el.classList.remove(cssClasses[i]);
				}
			}
		}

		if (mqMarker) {
			el.classList.add(mqMarker);
		}

		els.push(el);
	});

	return els;
});

/**
 * Unsupported browser message
 * @module avast.web.notSupportedBrowser
 * @version 1.0.0
 * @author Fedor Kušš
 * @requires jquery
 */

avm.define('avast.web.notSupportedBrowser', function() {
	'use strict';
	var $ = avm.require('jquery'),
		detectedBrowser = avastGlobals.detect.browser.name.toLowerCase(),
		detectedVersion = avastGlobals.detect.browser.version.toLowerCase(),
		notSupportedBrowser = detectedBrowser + detectedVersion.split('.')[0],
		$body = $('body');

	if (avastGlobals.detect.browser.isInternetExplorer || notSupportedBrowser === 'internetexplorer8' || notSupportedBrowser === 'internetexplorer9') {
		$body.addClass('notSupportedBrowser');
	}

})();

/**
 * Avast Router
 * @version 1.0.1
 * @author Michal Langhoffer <langhoffer@avast.com>
 * @module avast.web.router
 * @requires jquery
 */
avm.define('avast.web.router', (function () {
	'use strict';
	var $ = avm.require('jquery'),
		routes,
		self,
		w = window,
		$window = $(window);

	return {
		/*
		 * add window hashchange listener
		 * look for key in routes object and execute its function
		 */
		hashChangeListener: function () {
			self = this;
			$window.on('hashchange', function () {
				self.exec(w.location.hash.substring(1));
			});
		},
		/*
		 * @param {string} [path]
		 * change hash in URL if it is not the same as current one, otherwise execute function from routes object
		 */
		navigate: function (path) {
			if (w.location.hash.substring(1) !== path) {
				w.location.hash = path;
			} else {
				this.exec(path);
			}
		},
		/*
		 * @param {string} [path]
		 * execute function from routes object
		 */
		exec: function (path) {
			if (routes[path]) {
				routes[path]();
			} else {
				return;
			}
		},
		/*
		 * @param {object} [path]
		 * set the routes object
		 * add hashchange listener
		 * after page load check hash and execute function from routes object
		 * return routes object if path is object, otherwise throw error
		 */
		set: function (path) {
			routes = path;
			self = this;
			self.hashChangeListener();
			self.navigate(w.location.hash.substring(1));
			if (typeof path === 'object') {
				return routes;
			} else {
				throw new Error('Object has to be passed to router.set()');
			}
		}
	};
})());

/**
 * Serialize URL parameters from object to string
 * @version 1.1.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.url.serialize
 * @param {Object} urlObject
 * @returns {string}
 */
avm.define('avast.url.serialize', function(urlObject) {
	'use strict';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	if (typeof urlObject === 'object' && urlObject) {
		var urlString = '';
		for (var key in urlObject) {
			if (hasOwnProperty.call(urlObject, key)) {
				if (urlString.length) {
					urlString += '&';
				}
				urlString += encodeURIComponent(key) + '=' + encodeURIComponent(urlObject[key]);
			}
		}
		return urlString;
	} else {
		throw new Error('Invalid method arguments to avast.url.serialize');
	}
});

/**
 * Set cookie avastComLocale with locale value
 * @version 0.1.0
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.setLanguage
 */
avm.define('avast.web.setLanguage', function (lang) {
    'use strict';

    var d=new Date();
    d.setDate(d.getDate() + 365);
    document.cookie = "avastComLocale="+lang+";path=/;EXPIRES=" + d.toGMTString();
});

/**
 * Create slide counter bellow Carousel (TinySlider.js)
 * @version 0.1.0
 * @author Frantisek Rapcak <frantisek.rapcak@gendigital.com>
 * @module avast.web.slideCounter
 */
avm.define('avast.web.slideCounter', function (slider) {
	'use strict';

	var info = slider.getInfo(),
		name = info.container.classList[0],
		sliderEl = document.querySelector('[data-name=' + name + ']'),
		slideCounterEl = sliderEl.querySelector('.tns-liveregion');

	function updateCounter(info) {
		// calculate total slides and active slide
		// info.items is a number of items visible in viewport
		var totalSlides = info.items > 1 ? Math.ceil(info.slideCount / info.items) : info.slideCount,
			activeSlide = info.items > 1 ? Math.ceil(info.displayIndex / info.items) : info.displayIndex;

		slideCounterEl.innerHTML = activeSlide + '/' + totalSlides;
	}

	// Set initial counter value
	updateCounter(info);

	// Update the counter on slide change
	slider.events.on('transitionStart', updateCounter);

	// Update the counter on screen resize (new breakpoint)
	slider.events.on('newBreakpointEnd', updateCounter);
});

/**
 * Factory for storage object
 * @version 1.1.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.storage.storageFactory
 * @returns {Object}
 */
avm.define('avast.storage.storageFactory', function() {
	'use strict';
	var hasOwnProperty = Object.prototype.hasOwnProperty,
		data = {};
	return {
		length: 0,

		/**
		 * Add key/value pair
		 * @param {*} key
		 * @param {*} value
		 */
		setItem: function(key, value) {
			if (typeof key !== 'undefined' && typeof value !== 'undefined') {
				key = encodeURIComponent(key);
				value = encodeURIComponent(value);
				if (!hasOwnProperty.call(data, key)) {
					this.length++;
				}
				data[key] = value;
			} else {
				throw new Error('Invalid method arguments to avast.storage.storageFactory.setItem');
			}
		},

		/**
		 * Get value associated with key
		 * @param {*} key
		 * @returns {string}
		 */
		getItem: function(key) {
			if (typeof key !== 'undefined') {
				key = encodeURIComponent(key);
				return typeof data[key] !== 'undefined' ? decodeURIComponent(data[key]) : null;
			} else {
				throw new Error('Invalid method arguments to avast.storage.storageFactory.getItem');
			}
		},

		/**
		 * Remove key/value pair
		 * @param {*} key
		 */
		removeItem: function(key) {
			if (typeof key !== 'undefined') {
				key = encodeURIComponent(key);
				if (hasOwnProperty.call(data, key)) {
					delete data[key];
					this.length--;
				}
			} else {
				throw new Error('Invalid method arguments to avast.storage.storageFactory.removeItem');
			}
		},

		/**
		 * Get name of nth key
		 * @param {number} n
		 * @returns {string}
		 */
		key: function(n) {
			if (typeof n === 'number') {
				var i = 0;
				for (var key in data) {
					if (hasOwnProperty.call(data, key)) {
						if (i === n) {
							return decodeURIComponent(key);
						} else {
							i++;
						}
					}
				}
				return null;
			} else {
				throw new Error('Invalid method arguments to avast.storage.storageFactory.key');
			}
		},

		/**
		 * Clear all items
		 */
		clear: function() {
			data = {};
			this.length = 0;
		}

	};
});

/**
 * Script for adding Structured data to document head tag
 * @version 1.0.0
 * @author Cenek Hybler <hybler@avast.com>
 * @module avast.structuredData
 * @requires cash
 */

avm.define('avast.web.structuredData', function() {
	'use strict';
	var $ = avm.require('cash'),
		$faq_holder = $('[data-structured-type="faq"]'),
		$breadcrumblist_holder = $('[data-structured-type="breadcrumblist"]'),
		/* Function for JSON stringify and Script injection */
		jsonInjection = function(contextType, content){
			var el = document.createElement('script');
			var jsonIntro = {
					"@context": "http://schema.org",
					"@type": contextType
				},
				json = Object.assign(jsonIntro, content);

			el.type = 'application/ld+json';
			el.text = JSON.stringify(json);
			document.querySelector('head').appendChild(el);
		};

	$(document).ready(function(){

		//FAQ
		if ($faq_holder.length > 0) {
			var contextType = 'FAQPage',
				content = {},
				contentJson = [];
			
			$faq_holder.each(function(){
				var $items = $(this).find('.accordion-item');

				$items.each(function() {
					contentJson.push({
						"@type": "Question",
						"name": this.querySelector('.accordion-header').innerText.replace(/\n/g,'').replace(/\t/g,''),
						"acceptedAnswer": {
							"@type": "Answer",
							"text": this.querySelector('.accordion-body').innerHTML.replace(/\n/g,'').replace(/\t/g,'')
						}
					});
				});
				content['mainEntity'] = contentJson;
			});

			jsonInjection(contextType, content);
		}

		//BreadcrumbList
		if ($breadcrumblist_holder.length > 0) {
			$breadcrumblist_holder.each(function(){
				var contextType = 'BreadcrumbList',
					$crumbs = $(this).find('.breadcrumb-item'),
					content = {},
					contentJson = [];

				$crumbs.each(function(i) {
					var $crumbLink = $(this).find('.breadcrumb-item a'),
						crumbUrl = $crumbLink.attr('href'),
						crumbName = $(this).text().trim();

					if (window.document.URL && window.document.baseURI) {
						crumbUrl = crumbUrl ? new URL(crumbUrl, document.baseURI).href : undefined; // convert relative URL to absolute
					}					

					contentJson.push({
						"@type": "ListItem",
						"position": i+1,
						"name": crumbName,
						"item": crumbUrl
					})
				});
				content['itemListElement'] = contentJson;

				jsonInjection(contextType, content);
			});
		}
	});
});

/**
* Push data to GTM dataLayer.
* @version 1.0.0
* @author Ales Gabriel <gabriel@avast.com>
* @module avast.web.tracker
* @desc GTM dataLayer helper. Primary centralize various window.datalayer pushes.
* @requires jquery
*/
avm.define('avast.web.tracker', (function () {
	'use strict';

	var $ = avm.require('jquery');

	window.dataLayer = window.dataLayer || [];

	/*
	 *	Config events and handlers.
	 *	If tracked via GTM, only datalayer.push should be required.
	 */

	// Define callbacks for events
	var trackEvents = {
		'chromeOffer': {
			/**
			 * Track banner impression
			 * @return {Integer} Length of datalayer
			 */
			view: function(evt){
				//console.log(evt);
				return window.dataLayer.push({
					'event' : 'chromeOffer',
					'eventCategory' : 'Chrome',
					'eventAction' : 'Chrome Offer',
					'eventLabel' : 'View'
				});
			},
			/**
			 * Track clicking on download Chrome button
			 * @param  {Object} evt Event object
			 * @return {Integer}  Length of dataLayer
			 */
			click: function(evt){
				//console.log(evt);
				return window.dataLayer.push({
					'event' : 'chromeOffer',
					'eventCategory' : 'Chrome',
					'eventAction' : 'Chrome Offer',
					'eventLabel' : 'Click'
				});
			},
			/**
			 * Tracks Chrome Banner on page loads
			 * @param {Object} evt Event object
			 * @returns {Integer} Length of dataLayer
			 */
			onPageLoad: function(evt){
				//console.log(evt);
				return window.dataLayer.push({
					'event' : 'chromeOffer',
					'eventCategory' : 'Chrome',
					'eventAction' : 'Chrome Offer',
					'eventLabel' : 'View Opportunity'
				});
			}
		},
		'downloadPopup' : {
			view: function(obj) {
				return window.dataLayer.push({
					'event': 'av.virtualPageview',
					'virtualPageURL': '/' + obj.locale + '/download-overlay',
					'parentPage': obj.page
				});
			},
			close: function(obj) {
				return window.dataLayer.push({
					'event': 'downloadPopupClose',
					'virtualPageURL': '/' + obj.locale + '/download-overlay',
					'parentPage': obj.page
				});
			}
		},
		/**
		 * Password checker on first char - only once per visit
		 * @param  {Object} evt Event object
		 * @return {Int}     Length of dataLayer array
		 */
		'passwordCheck' : (function(){
			var called = 0;

			return function(evt){
				if(!called){
					called = 1;
					//console.log('passwordCheck event: %o', evt);
					return window.dataLayer.push({
						'event' : 'passwordCheck', // First char filled
					});
				}
			};
		})()
	};

	// Bind events
	$(document).on('passwordCheck.avast', function(){
		methods.track('passwordCheck');
	});

	///////////////////////////////////////////////////////////////////////////////////

	/*
	 * Methods
	 */
	var methods = {
		/**
		 * Track event
		 * @param  {String}   evtName  Event name. Looking for callback. Dot notation allowed.
		 * @param  {Object}   [evtObj]  Event object
		 * @param  {Function} [callback] Callback handler. If not defined in param, lookup on module internal callbacks storage is made.
		 */
		track: function(evtName, evtObj, callback){
			var handler = callback || trackEvents,
				spaces = (typeof evtName === 'string') ? evtName.split('.') : null,
				args = evtObj ? [evtObj] : [], // IE 8 with no arguments
				space,
				toString = Object.prototype.toString;

			// TODO: Do not step into object cycles if callback is only plain function by default
			if ((toString.call(handler) === '[object Function]' || toString.call(handler) === '[object Object]') && spaces && spaces.length > 0){
				for (var i = 0; i < spaces.length; i++) {
					space = spaces[i];
					if (handler !== null && space in handler) {
						handler = handler[space];

						// Function founded earlier than in last cycle considered as incorrect.
						// So properties defined on functions are not allowed.
						if (toString.call(handler) === '[object Function]' && i !== (spaces.length - 1)) {
							handler = null;
						}
					}
				}
			}

			if (typeof handler === 'function') {
				return handler.apply(this, args); // FIXME: Change to call.
			}
		}
	};


	// Export methods
	return methods;
})());

/**
 * Unserialize URL parameters from string to object
 * @version 1.2.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.url.unserialize
 * @param {string} [urlString]
 * @returns {Object}
 */
avm.define('avast.url.unserialize', function(urlString) {
	'use strict';
	urlString = typeof urlString === 'undefined' ? location.search : urlString;
	if (typeof urlString === 'string') {
		var urlObject = {},
			urlQuery = urlString.replace(/#.*|.*\?/g, '');
		if (urlQuery.length) {
			var urlParameters = urlQuery.split('&'),
				urlParametersLength = urlParameters.length,
				urlParameter = [];
			for (var i = 0; i < urlParametersLength; i++) {
				urlParameter = urlParameters[i].split('=');
				urlObject[decodeURIComponent(urlParameter[0])] = decodeURIComponent(urlParameter[1] || '');
			}
		}
		return urlObject;
	} else {
		throw new Error('Invalid method arguments to avast.url.unserialize');
	}
});

/**
 * Avast UrlBag (adds encoded params to cart links)
 * @version 0.1.0
 * @author Vojtech Sir <sir@avast.com>
 * @module avast.web.urlBag
 * @copyright Avast Software s.r.o &copy;2014
 */
avm.define('avast.web.urlBag', (function() {
    var urlBag = {
        data: {},
        addValue: function(key, value) {
            this.data[key] = String(value);
        },
        getData: function() {
            return this.data;
        },
        getEncodedData: function() {
            var base64 = this.base64encode(this.stringify(this.data));
            return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
        },
        stringify: function(obj) {
            if (typeof JSON != 'undefined' && JSON && JSON.stringify) {
                return JSON.stringify(obj);
            }

          var t = typeof(obj);
          if (t != 'object' || obj === null) {
            if (t == 'string') {
                    obj = '"' + obj + '"';
                }
            return String(obj);
          }
          else {
            var n, v, json = [], arr = (obj && obj.constructor == Array);

            for (n in obj) {
              v = obj[n]; t = typeof(v);
              if (t == 'string') v = '"' + v + '"';
              else if (t == 'object' && v !== null) v = this.stringify(v);
              json.push((arr ? "" : '"' + n + '":') + String(v));
            }
            return (arr ? '[' : '{') + String(json) + (arr ? ']' : '}');
          }
        },
        // http://phpjs.org/functions/base64_encode/
        base64encode: function(data) {
            if (!data) {
                return data;
            }

            var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
            var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = '', tmp_arr = [];

            do { // pack three octets into four hexets
                o1 = data.charCodeAt(i++);
                o2 = data.charCodeAt(i++);
                o3 = data.charCodeAt(i++);

                bits = o1 << 16 | o2 << 8 | o3;

                h1 = bits >> 18 & 0x3f;
                h2 = bits >> 12 & 0x3f;
                h3 = bits >> 6 & 0x3f;
                h4 = bits & 0x3f;

                // use hexets to index into b64, and append result to encoded string
                tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
            } while (i < data.length);

            enc = tmp_arr.join('');
            var r = data.length % 3;
            return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
        }
    };

    return urlBag;

 })());

/**
 * Waypoints
 * @version 1.3.0
 * @author Michal Langhoffer <langhoffer@avast.com>, Ales Gabriel <gabriel@avast.com>, Cenek Hybler <hybler@avast.com>
 * @module avast.web.waypoints
 * @description Waypoints return true if top/bottom coordinates of element are in the viewport (with optional offsets)
 * @requires cash
 * @param {jQuery Object / Element / String} waypointElement
 * @param {Number} offsetTop
 * @param {Number} offsetBottom
 * @param {Boolean} waypoint
 * @returns {boolean}
 */

avm.define('avast.web.waypoints', function(waypointElement, offsetTop, offsetBottom, waypoint) {
	'use strict';

	/*
	waypointElement - can be either String selector, Element (created by querySelector) or jQuery object (later is deprecated as we are trying to get rid of jQuery completely.)

	Offsets can be defined as:
	a) fraction of element height (decimal.value < 1)
	b) absolute pixel size (value >= 1)
	*/

	var
		$ = avm.require('cash'),
		el;

		// is waypointElement String, Element or Object?
		if (Object.prototype.toString.call(waypointElement) === '[object String]') {
			el = document.querySelector(waypointElement); // select entity by string selector

		} else if (waypointElement instanceof Element) {
			el = waypointElement; // assign provided entity directly

		} else {
			el = $(waypointElement)[0]; // extract first entity from the object
		}


	if (el && el instanceof Element) {
		var
			// Element's properties:
			elTop = el.getBoundingClientRect().top,
			elBottom = el.getBoundingClientRect().bottom,
			elHeight = el.getBoundingClientRect().height,

			viewportHeight = document.documentElement.clientHeight,

			// Element offset above bottom viewport edge. How many pixels from top of the element must be visible above bottom of vieport.
			offsetTop = offsetTop ? offsetTop : 0,
			// Element offset under top viewport edge. How many pixels from bottom of the element is the maximum.
			offsetBottom = offsetBottom ? offsetBottom : 0;


		// calculte top offset as a fraction of height
		if (offsetTop < 1 && offsetTop !== 0) {
			offsetTop = elHeight * offsetTop;
		}
		// calculte bottom offset as a fraction of height
		if (offsetBottom < 1 && offsetBottom !== 0) {
			offsetBottom = elHeight * offsetBottom;
		}


		if (waypoint) {
			// If true, only returns whether the given element's top edge is scrolled above viewport.
			// OffsetTop moves the point above or below the element. Positive value triggers it sooner.

			return elTop <= offsetTop;

		} else {
			// Else trigger true statement as long the element is in the viewport (minus offsets). If the element's top is above the viewport bottom AND element's bottom is bigger the 0 (means there is visible at least a part of it)

			return (elTop - offsetTop < viewportHeight) && (elBottom - offsetBottom > 0);
		}
	} else {
		return false;
	}
});

/**
 * Avast Aswparam (adds /ASWPARAM to cart links)
 * @version 0.5.0
 * @author Vojtech Sir <sir@avast.com>, Ales Gabriel <gabriel@avast.com>, Michal Langhoffer <langhoffer@avast.com>
 * @module avast.web.aswparam
 * @requires module:jquery
 * @requires module:avast.web.urlBag
 * @requires module:avast.web.clientInfo
 * @copyright Avast Software s.r.o &copy;2015
 */

avm.define('avast.web.aswparam', (function() {

    var $ = avm.require('jquery'),
        urlBag = avm.require('avast.web.urlBag');

    var aswparam = {
        inited: false,
        cartLinks: {
            'CX': {
                urls: ['store.avast.com'],
                paramPattern: '/ASWPARAM.%urlBagValue%',
                paramRegex: /(\/ASWPARAM\.)[^/]+/,
                appendBeforeRegex: /(\/ThemeID\.)/
            },
            'SL': {
                urls: ['store.avast.ru', 'store-kz.avast.com', 'store.avast.ua', 'store-sl.avast.com'],
                paramPattern: 'ASWPARAM=%urlBagValue%&',
                paramRegex: /(&(amp;)?ASWPARAM=)[^&]+/,
                appendBeforeRegex: /(quantity=)/
            }
        },
        globalCartLinks: ['store.avast.com', 'store.avast.ru', 'store-kz.avast.com', 'store.avast.ua', 'store-sl.avast.com'],
        init: function(){
            var cookies = {'p_pro': 'x-avast-pro', 'p_vbd': 'x-avast-vbd', 'p_hid': 'x-avast-hid'},
                testCookieFail = ['p_pro', 'p_vbd'],
                urlParams = {'p_glic': 'p_glic'},
                values = {},
                cookieFail = false,
                aswparam = this,
                paramsFromUrl = avm.require('avast.url.unserialize')(window.location.href);

            /* OO-8998 */
            if (window.location.pathname.indexOf('cleanup') > -1) {
                   if (typeof paramsFromUrl.ppc !== 'undefined' && paramsFromUrl.ppc.length > 0) {
                    values.ppc = paramsFromUrl.ppc;
                   }
            }
            /* /OO-8998 */

            /* WCS-2448 */
            $(document).on('priceUpdate.ab.avast avast.ab.updatePrice avast.bab.updatePrice', function() {
                aswparam.updateAswparamPlaceholderLinks(aswparam.globalCartLinks, paramsFromUrl.aswparam);
             });

            if (paramsFromUrl.aswparam && paramsFromUrl.aswparam.length > 0) {
                aswparam.updateAswparamPlaceholderLinks(aswparam.globalCartLinks, paramsFromUrl.aswparam);
            } else {
                aswparam.updateAswparamPlaceholderLinks(aswparam.globalCartLinks);
            /* /WCS-2448 */

                $.each(cookies, function(paramName, cookieName) {
                    values[paramName] = aswparam.getClientInfo(paramName, cookieName);
                    if ($.inArray(paramName, testCookieFail) > -1 && !values[paramName]) {
                        cookieFail = true;
                    }
                });

                if (!cookieFail) {
                    $.each(values, function(name, value) {
                        urlBag.addValue(name, value);
                    });

                    $.each(urlParams, function(paramName, urlParamName) {
                        var urlParamValue = aswparam.getURLParameter(urlParamName);

                        if (urlParamValue) {
                            urlBag.addValue(paramName, urlParamValue);
                        }
                    });

                    this.updateLinks();
                }
            }
        },
        updateLinks: function(){
            var aswparam = this;

            // Web page
            $('a').each(function() {
                var link = aswparam.linkDecorator(this.href);
                // Decorate only cart links.
                if(link){
                    this.href = link;
                }
            });
            // INTs, LPs
            $('.choice', '.selection').each(function() {
                var input = $(this).find('input[type=radio]');
                var link = aswparam.linkDecorator(input.val());
                if(link){
                    input.val(link);
                }
            });
            // for dynamically loaded prices
            if (!this.inited) {
                // TODO: Remove 'avast.ab.updatePrice', 'avast.bab.updatePrice' events, when all triggers replaced with 'priceUpdate.ab.avast'.
                $(document).on('priceUpdate.ab.avast avast.ab.updatePrice avast.bab.updatePrice', function() {aswparam.updateLinks();});
                this.inited = true;
            }
        },
        getCookieValue: function(name) {
            var value = '; ' + document.cookie;
            var parts = value.split('; ' + name + '=');
            return (parts.length >= 2) ? parts.pop().split(';').shift() : null;
        },
        getURLParameter: function(name) {
            return decodeURI((RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||[,null])[1]);
        },
        linkDecorator: function(link){
            var href;
            var urlBagEncodedData = urlBag.getEncodedData();

            if (urlBagEncodedData) {
                $.each(this.cartLinks, function (provider, providerDef) {
                    $.each(providerDef.urls, function (key, providerUrl) {
                        if (link.indexOf(providerUrl) != -1) {
                            if (link.search(providerDef.paramRegex) > -1) {
                                href = link.replace(providerDef.paramRegex, '$1' + urlBagEncodedData);
                            } else {
                                href = link.replace(providerDef.appendBeforeRegex, providerDef.paramPattern.replace('%urlBagValue%', urlBagEncodedData) + '$1');
                            }
                        }
                    });
                });
            }
            return href;
        },
        getClientInfo: function(paramName, cookieName){
            var client = (window.avastGlobals && window.avastGlobals.client) ? window.avastGlobals.client : null,
                value;

            if(client){
                value = (client[paramName] === 'null') ? null : client[paramName];
            } else {
                value = this.getCookieValue(cookieName + '-i') ? this.getCookieValue(cookieName + '-i') : this.getCookieValue(cookieName);
            }

            return value;
        },
        updateAswparamPlaceholderLinks: function(globalCartLinks, aswparamValue) {
            const linkAswparamPlaceholder = '{aswparam}';
            var newLink,
                cartLinks = [];

            $('a').not('a[href^="#"]').each(function() {
                var el = this;
                var link = el.href;
                $.each(globalCartLinks, function (provider, providerUrl) {
                    if (link.indexOf(providerUrl) != -1) {
                        cartLinks.push(el);
                    }
                });
            });

            $.each(cartLinks, function (el, link) {
                if(aswparamValue && $(this).data('aswparam-placeholder')) {
                    var elDataAswparamPlaceholder = $(this).data('aswparam-placeholder');
                    aswparam = elDataAswparamPlaceholder.replace('{ASWPARAM}', aswparamValue);

                    if (link.href.indexOf(linkAswparamPlaceholder) != -1 || link.href.indexOf(escape(linkAswparamPlaceholder) != -1)) {
                        newLink = link.href.indexOf(escape(linkAswparamPlaceholder)) != -1 ? link.href.replace(escape(linkAswparamPlaceholder), aswparam) : link.href.replace(linkAswparamPlaceholder, aswparam);

                        $(link).attr('href', newLink);
                    }
                } else {
                    newLink = link.href.indexOf(escape(linkAswparamPlaceholder)) != -1 ? link.href.replace(escape(linkAswparamPlaceholder), '') : link.href.replace(linkAswparamPlaceholder, '');

                    $(link).attr('href', newLink);
                }
            });

        }
    };

    return aswparam;

})());

// affiliate aswparam from url parameters GLOWEB-7251
(function() {
    'use strict';

    try {
        // get parameters from url
        var urlParams = location.search.toLowerCase();

        // check if url contains some of the affiliate parameters
        if (/programtype|partnerid|clickid|trafficsource/.test(urlParams)) {
            var aswObj = {},
                aswparam = '';

            // put parameters from url to object
            //safari fix, remove when safari starts working
            //if (/partnerid=/.test(urlParams)) aswObj.partnerid = urlParams.match(/(?<=partnerid=).*?(?=&)|(?<=partnerid=).*?$/)[0];
            //if (/programtype=/.test(urlParams)) aswObj.programtype = urlParams.match(/(?<=programtype=).*?(?=&)|(?<=programtype=).*?$/)[0];
            //if (/clickid=/.test(urlParams)) aswObj.clickID = urlParams.match(/(?<=clickid=).*?(?=&)|(?<=clickid=).*?$/)[0];
            //if (/trafficsource=/.test(urlParams)) aswObj.trafficSource = urlParams.match(/(?<=trafficsource=).*?(?=&)|(?<=trafficsource=).*?$/)[0];
            if (/partnerid=/.test(urlParams)) {
                aswObj.partnerid = urlParams.match(/(?:partnerid=).*?(?=&)|(?:partnerid=).*?$/)[0].replace(/partnerid=/, '');
            }

            if (/programtype=/.test(urlParams)) {
                aswObj.programtype = urlParams.match(/(?:programtype=).*?(?=&)|(?:programtype=).*?$/)[0].replace(/programtype=/, '');
            }

            if (/clickid=/.test(urlParams)) {
                aswObj.clickID = urlParams.match(/(?:clickid=).*?(?=&)|(?:clickid=).*?$/)[0].replace(/clickid=/, '');
            }

            if (/trafficsource=/.test(urlParams)) {
                aswObj.trafficSource = urlParams.match(/(?:trafficsource=).*?(?=&)|(?:trafficsource=).*?$/)[0].replace(/trafficsource=/, '');
            }

            // encode object to base64
            aswparam = btoa(JSON.stringify(aswObj));

            if (!sessionStorage.getItem("aswparam")) {
                sessionStorage.setItem("aswparam", aswparam);
            }

            setAswparamOnButton(aswparam);

        } else if (sessionStorage.getItem("aswparam")) {
            setAswparamOnButton(sessionStorage.getItem("aswparam"));
        };

        function setAswparamOnButton(aswparam) {
            var buylinks = document.querySelectorAll('[data-role="cart-link"]');
            // check if there any buttons on page
            if (buylinks.length > 0) {

                // for each buy link update href
                buylinks.forEach(function(link) {
                    updateLink(link, aswparam)
                });
            };

            // event listener for change in actionbox
            window.addEventListener('pricebox-updated', function(e) {
                e.detail.element.querySelectorAll('[data-role="cart-link"]').forEach(function(link) {
                    updateLink(link, aswparam)
                });
            });

        }

        // check if link doesn't contain aswparam and add it
        function updateLink(link, aswparam) {
            if(!/aswparam/.test(link.href)) {
                link.href = link.href + '&aswparam=' + aswparam;
            };
        }

    } catch (error) {
        console.error(error);
        sdl.push({
            system: {
                error: {
                    type: error.name,
                    message: error.message,
                }
            },
            event: 'system.error'
        })
    }
}());

/**
 * Avast brcmpgid parameter
 * @version 1.0.0
 * @author Jaroslav Slaby <jaroslav.slaby@avast.com>
 * @module avast.web.brcmpgid
 * @requires avast.url.unserialize
 * @requires avast.web.linkDecorator
 * @copyright Avast Software s.r.o &copy;2021
 */

(function() {
	'use strict';
	
	// check for brcmpgid parameter in url and if URLSearchParams method exists in browser
	if (/brcmpgid/.test(location.search) && 'URLSearchParams' in window) {
		var unserialize = avm.require('avast.url.unserialize'),
			qs = unserialize(),
			productId = 'ASB',
			valueTest = /^[a-z0-9]+$/i,
			ASBLinks = document.querySelectorAll('[data-download-name*="' + productId + '"]');

		ASBLinks.forEach(function(el) {
			try {
				var downloadURL,
					downloadQueryString;

				if(!/ANDROID|IOS/.test(el.getAttribute('data-download-name')) && qs && qs.brcmpgid && valueTest.test(qs.brcmpgid)) {
					if (el.href) {
						downloadURL = new URL(el.href);
						downloadQueryString = new URLSearchParams(downloadURL.search);

						downloadQueryString.set('product', (el.getAttribute('data-download-name') !== null ? el.getAttribute('data-download-name') : el.getAttribute('data-bi-download-name')) + '-CID');

						if (qs.brcmpgid !== undefined) {
							downloadQueryString.set('tag', qs.brcmpgid);
						}

						if (qs.source_tag !== undefined) {
							downloadQueryString.set('source_tag', qs.source_tag);
						}

						downloadURL.search = downloadQueryString.toString();
						el.href = downloadURL.toString();
					}
				}

			} catch (error) {
				// singe data layer error tracking
				if (typeof sdl !== 'undefined') {
					console.error(error);
					sdl.push({
						system: {
							error: {
								type: error.name,
								message: error.message,
							}
						},
						event: 'system.error'
					})
				}
			}
		})	
	}

	return;

})();

/**
 * Display Chrome Offer in non-chrome browsers
 * @version 1.2.0
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.chromeBanner
 * @requires jquery
 * @requires avast.url.unserialize
 * @requires avast.web.tracker
 */
avm.define('avast.web.chromeBanner', (function() {
	'use strict';

	var $ = avm.require('jquery');
	var detect = avastGlobals.detect.browser;
	var urlParams = avm.require('avast.url.unserialize')();
	var tracker = avm.require('avast.web.tracker');
	var $window = $(window);
	var waypoints = avm.require('avast.web.waypoints');

	// Chrome banner
	var chromeBanner = {
		init: function() {
			var hasBanner = $('#offer-chrome').length,
				isChrome = detect.isChrome,
				isAsb = detect.isAvast,
				product = typeof urlParams.product === 'string' ? urlParams.product : '',
				isMsBuild = product.indexOf('-ONLINE-MS') > -1;

			if (hasBanner && !isChrome && !isMsBuild && !isAsb) {
				this.show();
				$('#offer-chrome [data-role="cta-link"]').on('click', this.trackClick);
			} /* else if (isChrome) {
				// Display Secure Browser product offer in chrome browsers inside Cross promo section
				// $('[data-product="secureBrowser"]').removeClass('d-none');
			} */
		},
		show: function(e) {
			var url = document.location.href,
				pExt = url.match(/[?&]p_ext=([^&]*)/),
				pExtVal = pExt ? pExt[1].toLowerCase() : '';

			if (url.indexOf('?') > -1) {
				url = url.substr(0, url.indexOf('?'));
			}

			if (pExtVal.indexOf('chrome') == -1 && !/secure-browser/.test(url) && !/download-thank-you.php/.test(url)) {
				$('#offer-chrome').show();

				tracker.track('chromeOffer.onPageLoad', e);

				// adding custom name on query method allows to turn off resize, scroll events ONLY for this specific method
				$window.on('resize.myResize scroll.myScroll', function() {
					if (waypoints($('#offer-chrome'), null, null)) {
						tracker.track('chromeOffer.view', e)
						$window.off('resize.myResize').off('scroll.myScroll');
					}
				});

			}
		},
		trackClick: function(e) {
			tracker.track('chromeOffer.click', e);
		}
	};

	return chromeBanner;

})());

/**
 * Wrapper for cookieStorage object
 * @version 1.1.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.storage.cookieStorage
 * @requires avast.storage.isCookieEnabled
 * @requires avast.storage.storageFactory
 */
avm.define('avast.storage.cookieStorage', (function() {
	'use strict';
	var isCookieEnabled = avm.require('avast.storage.isCookieEnabled'),
		storageFactory = avm.require('avast.storage.storageFactory'),
		toString = Object.prototype.toString,
		keys = function() {
			return document.cookie.replace(/((?:^|\s*;)[^=]+)(?=;|$)|^\s*|\s*(?:=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:=[^;]*)?;\s*/);
		},
		cookieStorage = {
			length: document.cookie !== '' ? keys().length : 0,

			/**
			 * Add key/value pair
			 * @param {*} key
			 * @param {*} value
			 * @param {string|date} [expires]
			 * @param {string} [path]
			 * @param {string} [domain]
			 * @param {boolean} [secure]
			 */
			setItem: function(key, value, expires, path, domain, secure) {
				if (typeof key !== 'undefined' && typeof value !== 'undefined') {
					var regExp = /^(?:expires|max\-age|path|domain|secure)$/i;
					key = encodeURIComponent(key);
					value = encodeURIComponent(value);
					if (key && !regExp.test(key)) {
						if (document.cookie.indexOf(key) === -1) {
							this.length++;
						}
						if (typeof expires === 'string') {
							expires = '; expires=' + expires;
						} else if (toString.call(expires) === '[object Date]') {
							expires = '; expires=' + expires.toUTCString();
						}
						document.cookie = key + '=' + value + (typeof expires === 'string' ? expires : '') + (typeof domain === 'string' ? '; domain=' + domain : '') + (typeof path === 'string' ? '; path=' + path : '') + (secure ? '; secure' : '');
					}
				} else {
					throw new Error('Invalid method arguments to avast.storage.cookieStorage.setItem');
				}
			},

			/**
			 * Get value associated with key
			 * @param {*} key
			 * @returns {string|null}
			 */
			getItem: function(key) {
				if (typeof key !== 'undefined') {
					var regExp = new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$');
					return decodeURIComponent(document.cookie.replace(regExp, '$1')) || null;
				} else {
					throw new Error('Invalid method arguments to avast.storage.cookieStorage.getItem');
				}
			},

			/**
			 * Remove key/value pair
			 * @param {*} key
			 * @param {string} [path]
			 * @param {string} [domain]
			 */
			removeItem: function(key, path, domain) {
				if (typeof key !== 'undefined') {
					key = encodeURIComponent(key);
					if (document.cookie.indexOf(key) !== -1) {
						this.length--;
					}
					document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + (typeof domain === 'string' ? '; domain=' + domain : '') + (typeof path === 'string' ? '; path=' + path : '');
				} else {
					throw new Error('Invalid method arguments to avast.storage.cookieStorage.removeItem');
				}
			},

			/**
			 * Get name of nth key
			 * @param {number} n
			 * @returns {string}
			 */
			key: function(n) {
				if (typeof n === 'number') {
					var keysArray = keys(),
						keysArrayLength = keysArray.length;
					if (n < keysArrayLength) {
						return decodeURIComponent(keysArray[n]);
					} else {
						return null;
					}
				} else {
					throw new Error('Invalid method arguments to avast.storage.cookieStorage.key');
				}
			},

			/**
			 * Clear all items
			 */
			clear: function() {
				var keysArray = keys(),
					keysArrayLength = keysArray.length;
				for (var i = 0; i < keysArrayLength; i++) {
					this.removeItem(keysArray[i]);
				}
				this.length = document.cookie !== '' ? keys().length : 0;
			}

		};
	return isCookieEnabled ? cookieStorage : storageFactory();
})());

/**
* Decorate cart link with showCuponeCode parameter
* @version 1.1.3
* @author Ales Gabriel, Michal Langhoffer
* @module avast.web.couponCode
* @requires jquery
* @requires avast.storage.cookieStorage
*/
avm.define('avast.web.couponCode', (function () {
    'use strict';

    var $ = avm.require('jquery'),
        cookieStorage = avm.require('avast.storage.cookieStorage');

    return {
        options: {
           regexS: '[\\?&]couponfield=yes([^&#]*)',
           providers:['dr-store.avast.com','store.avast.com','store.avast.ru'],
           urlQuery: '/showCouponCode=yes'
         },

         init: function(params){
            var root = this;
            if(params !== undefined){
                for(var param in params){
                    this.options[param] = params[param];
                }
            }

            var regex = new RegExp(this.options.regexS,"i");
            var results = regex.exec(window.location.href);

            if(results === null){
                return 1;
            } else {
                var href;
                var couponParam = this.options.urlQuery;
                var providers = this.options.providers;
                var cookieExpirationTime = new Date();

                function getHostname() {
                    var hostnameSplitted = window.location.hostname.split('.');

                    if (hostnameSplitted[hostnameSplitted.length - 2] === 'avast' && hostnameSplitted[hostnameSplitted.length - 1] === 'com') {
                        return '.avast.com';
                    } else {
                        return window.location.hostname.substring(3);
                    }
                }

                $("a").each(function(){
                    href = $(this).attr('href') ? $(this).attr('href') : "";
                    for(var i=0;i<providers.length;i++){
                        if(href.indexOf(providers[i]) != -1 && href.indexOf(couponParam) == -1){
                            href = href + couponParam;
                            $(this).attr('href',href);
                        }
                    }
                });

                cookieExpirationTime.setMonth(cookieExpirationTime.getMonth() + 2); // expiration set to 2 months
                cookieStorage.setItem('couponfield', 'yes', cookieExpirationTime, '/', getHostname());
            }
         }
     };
})());

/**
 * download-popup, oops popup and cross sell popup
 * @version 2.1.0
 * @author Jaroslav Slaby <jaroslav.slaby@gendigital.com>
 * @module avast.web.downloadPopup
 * @requires avast.web.tracker
 * @copyright Avast Software s.r.o &copy;2023
 */

avm.define('avast.web.downloadPopup', (function() {
	'use strict';

	var tracker = avm.require('avast.web.tracker'),
		detect = avastGlobals.detect,
		browser = detect.browser,
		os = detect.os,
		userPlatform = avastGlobals.detect.browser.platform,
		trackingObj = {
			locale: avastGlobals.web.locale,
			page: '/' + avastGlobals.web.locale + '/' + avastGlobals.web.pathFromRoot
		},
		downloadPopup = {
			init: function() {
				var popups = document.querySelectorAll('.js-popup-dtp[data-role="popup"][data-cmp-name="dtyp-popup"]'),
					buttons = document.querySelectorAll('a[data-role="download-link"]:not(.js-downloadPopup-fallback-link)'),
					self = this;

				// if some popup exist
				if (popups.length > 0) {
					// popup settings
					popups.forEach(function(popupEl) {
						// A11y popup setup
						popupEl.setAttribute('tabindex', '-1');
						// TODO: change HTML (span -> button) and remove this row
						if (popupEl.querySelector('.js-dtp-close')) {
							popupEl.querySelector('.js-dtp-close').setAttribute('tabindex', 0);
							popupEl.querySelector('.js-dtp-close').setAttribute('role', 'button');
						}
					});
				}

				// set popup on each download button
				buttons.forEach(function(button) {
					self.setPopup(button);
				});
			},
			setPopup: function(button) {
				var self = this;

				// check if button hasn't already set some popup
				if (button.getAttribute('js-popup-event') !== 'true') {

					// check for cross sell
					// cross sell testing cookie: document.cookie = "clientTest=true; max-age=60; path=/;";
					if (!browser.isAvast && os.isWindows && (avastGlobals.client !== undefined || /clientTest=true/.test(document.cookie)) && self.isCrosssellBtnCorrect(button)) {
						// set cross sell popup
						crossSellModal(button);
						// prevents duplicity of events on button
						button.setAttribute('js-popup-event', 'true');

					// check for oops
					} else if (self.isOopsBtnCorrect(button) && button.getAttribute('data-platform').toLowerCase() !== userPlatform) {
						// set oops
						oopsModal(button);
						// prevents duplicity of events on button
						button.setAttribute('js-popup-event', 'true');

					// else check for dtyp
					} else if (self.isDownloadBtnCorrect(button)) {
						// set download popup
						downloadModal(button);
						// prevents duplicity of events on button
						button.setAttribute('js-popup-event', 'true');
					}
				}

				function crossSellModal(button) {
					var csrossSellModalElement = document.getElementById('cross-sell-modal'),
						bsnModal = new BSN.Modal(csrossSellModalElement), // define bootstrap modal
						modalButtons = csrossSellModalElement.querySelectorAll('[data-role="download-link"]'); // download buttons in modal

					// exclude buttons in oops modal (prevents loop)
					if (button.closest('.modal-oops') === null) {
						button.addEventListener('click', function(event) {
							event.preventDefault(); // disable file download
							event.stopPropagation(); // disable download tracking

							// open bootstrap modal
							bsnModal.show()

							// closing modal by clicking download button
							modalButtons.forEach(function(btn) {
								btn.addEventListener('click', function() {
									bsnModal.hide();
								})
							});
						})
					}
				}

				function downloadModal(button) {
					var downloadId = button.getAttribute('data-download-name'),
						isRuExternalDownload = avastGlobals.web.locale === 'ru-ru' && browser.isChrome && /FAV-/.test(downloadId), // external download for RU chrome
						isPlExternalDownload = avastGlobals.web.locale === 'pl-pl' && /FAV-/.test(downloadId); // external download for PL

					// is not mobile platforms, external downloads or leads to app stores
					if (!os.isAndroid && !os.isIOS && !isRuExternalDownload && !isPlExternalDownload && !/apps.apple|play.google/.test(button.href)) {


						// default or alternative download popup exist
						if (button.getAttribute('data-target') || document.querySelectorAll('[data-cmp-name="dtyp-popup"]').length > 0) {

							// set direct=1 parameter for direct download
							var url = new URL(button.href),
								params = url ? url.searchParams : null;

							params.set('direct', 1);
							url.search = params.toString();
							button.href = url.toString();

							button.addEventListener('click', function(e) {
								// Check for alternative download popup or use default
								var popup = button.hasAttribute('data-target') ? document.getElementById(button.getAttribute('data-target')) : document.querySelector('#downloadPopup[data-cmp-name="dtyp-popup"]'),
									closeButton = popup.querySelector('.js-dtp-close'),
									progress = popup.querySelector('.dtyp-progress'),
									note = popup.querySelector('.dtyp-note'),
									fallback = popup.querySelectorAll('.js-downloadPopup-fallback-link');

								// Set attributes to fallback links
								if (fallback) {
									fallback.forEach(function(anchor) {
										anchor.setAttribute('data-download-name', button.getAttribute('data-download-name'));
										anchor.setAttribute('data-bi-download-name', button.getAttribute('data-bi-download-name'));
										anchor.href = button.href;
									});
								}

								// Progress spinner and manual link animation
								if (progress && note) {
									progress.classList.add('dtyp-progress-show');
									progress.classList.remove('d-none');
									note.classList.remove('dtyp-note-show');
									note.classList.add('d-none');

									setTimeout(function() {
										progress.classList.remove('dtyp-progress-show');
										setTimeout(function() {
											progress.classList.add('d-none');
											note.classList.remove('d-none');
											note.classList.add('dtyp-note-show');
										}, 330);
									}, 3000);
								}

								// Show popup
								popup.classList.remove('d-none');
								setTimeout(function() {
									popup.classList.add('is-open');
									document.body.classList.add('dtypup-open');
								}, 10);

								tracker.track('downloadPopup.view', trackingObj);

								// a11y
								popup.setAttribute('tabindex', '0');
								popup.focus();

								// Close popup by browser's back button
								window.history.pushState({
									state: 1
								}, 'Avast', window.location.href);

								// Close popup handlers
								self.closeHandler(popup, button, closeButton, fallback, document.activeElement);
							});
						}
					}
				}

				function oopsModal(button) {
					// popup for wrong downloaded platform
					button.addEventListener('click', function (e) {
						var downloadPlatform = this.getAttribute('data-platform').toLowerCase(),
							modal = document.querySelector('#' + this.getAttribute('data-oops-target')),
							modalButtons = modal.querySelectorAll('[data-role="download-link"]');

						// interupt downloading file
						e.preventDefault();
						e.stopPropagation();

						// can be replaced by styles in css
						var styleReset = modal.querySelectorAll('[class*="js-oops-"]');
						for (var x = 0; x < styleReset.length; x++) {
							styleReset[x].style.display = 'none';
						}

						// show title by user's platform
						if (modal.querySelector('.js-oops-title-' + userPlatform)) {
							modal.querySelector('.js-oops-title-' + userPlatform).style.display = 'block';
						}

						// show description by user's and downloaded platforms
						if (modal.querySelector('.js-oops-desc-custom-' + userPlatform)) {
							modal.querySelector('.js-oops-desc-custom-' + userPlatform).style.display = 'block';
						}
						if (modal.querySelector('.js-oops-desc-' + userPlatform + '-' + downloadPlatform)) {
							modal.querySelector('.js-oops-desc-' + userPlatform + '-' + downloadPlatform).style.display = 'block';
						}

						// show primary button by user's platform
						if (modal.querySelector('.js-oops-primary-' + userPlatform)) {
							modal.querySelector('.js-oops-primary-' + userPlatform).style.display = 'block';
						}

						// show secondary button by downloaded platform if 'secondaryDisabled' parameter is not set
						if (!modal.classList.contains('js-oops-disabled-' + userPlatform) && modal.querySelector('.js-oops-secondary-' + downloadPlatform)) {
							modal.querySelector('.js-oops-secondary-' + downloadPlatform).style.display = 'block';
						}

						// prevent incorrect behavior while popup in popup is used
						var bsnModal = new BSN.Modal(modal);
						setTimeout(function() {
							// show oops modal
							bsnModal.show()
						}, 300);

						// tracking of closing modal without download
						modal.addEventListener('hide.bs.modal', function(){
							if (typeof dataLayer !== 'undefined') dataLayer.push({"event": "compatibilityPopupClosed"});
							avastGlobals.web.disableDtyp = false;
						},{ once: true });

						// closing modal by clicking download button
						modalButtons.forEach(function(btn) {
							btn.addEventListener('click', function() {
								// close modal
								bsnModal.hide();
							})
						});
					});
				}

			},
			closeHandler: function(popup, openBtn, closeBtn, fallbackLink, focusedElement) {
				// close on ESC or tabindex by TAB
				window.addEventListener('keyup', keypress);
				// press enter on close button
				closeBtn.addEventListener('keyup', closeByEnter);
				// click on close button
				closeBtn.addEventListener('click', closePopup);
				// browser history back
				window.addEventListener('popstate', closePopup);

				function closeByEnter(e) {
					if (e.keyCode === 13) {
						closePopup();
					}
				}

				function keypress(e) {
					if (popup.classList.contains('is-open')) {
						// close popup by ESC
						if (e.keyCode === 27) {
							closePopup();
						}

						// A11y Tab in popup
						if (e.keyCode === 9) {
							focusedElement === fallbackLink ? closeBtn.focus() : fallbackLink.focus();
							focusedElement = document.activeElement;
						};
					}
				}

				function closePopup() {
					popup.classList.remove('is-open');
					document.body.classList.remove('dtypup-open');
					setTimeout(function() {
						popup.classList.add('d-none');
					}, 250);

					// a11y disable tab index and set focus to button
					popup.setAttribute('tabindex', '-1');
					openBtn.focus();

					window.removeEventListener('keyup', keypress);
					closeBtn.removeEventListener('keyup', closeByEnter);
					closeBtn.removeEventListener('click', closePopup);
					window.removeEventListener('popstate', closePopup);

					tracker.track('downloadPopup.close', trackingObj);
				}
			},
			dtypExists: function() {
				// check if download popup exist on page
				return document.querySelectorAll('.js-popup-dtp[data-role="popup"][data-cmp-name="dtyp-popup"]').length > 0 ? true : false;
			},
			isDownloadBtnCorrect: function(button) {
				// check if it is correct download button
				return (button.hasAttribute('data-role') && button.getAttribute('data-role') === 'download-link' && !button.classList.contains('js-downloadPopup-fallback-link') && button.getAttribute('data-behavior') !== 'downloadPage') ? true : false;
			},
			isOopsBtnCorrect: function(button) {
				// check if button has all needed attributes for oops
				return (button.hasAttribute('data-role') && button.getAttribute('data-role') === 'download-link' && button.hasAttribute('data-platform') && button.hasAttribute('data-oops-target') && button.getAttribute('data-oops-target') !== '' && document.getElementById(button.getAttribute('data-oops-target')) && document.querySelector('#' + button.getAttribute('data-oops-target'))) ? true : false;
			},
			isCrosssellBtnCorrect: function(button) {
				// check if button has all needed attributes for cross sell
				return (button.hasAttribute('data-role') && button.getAttribute('data-role') === 'download-link' && button.hasAttribute('data-download-name') && /FAV/.test(button.getAttribute('data-download-name')) && !button.classList.contains('cross-sell-btn') && document.getElementById('cross-sell-modal')) ? true : false;
			}
		};

	return downloadPopup;
})());

/**
 * Decorate link with params
 * @version 1.1.0
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.linkdecorator
 * @requires jquery
 * @requires avast.url.unserialize
 * @param {string} selector Css selector. Matched elements will be decorated
 * @param {(string|string[])} params Name or array of names
 * @param {string} [querystring] Optionally you can set querystring parameter manually. In this case querystring from URL will be ignored.
 * @param {string} [newValue] Optionally value can be set
 * @returns {object} jQuery object of selected elements
 */

avm.define('avast.web.linkDecorator', function(selector, params, querystring, newValue){
	'use strict';

	var $ = avm.require('jquery'),
		query = querystring ? querystring : undefined,
		unserialize = avm.require('avast.url.unserialize'),
		urlParams = unserialize(query),
		paramArr = (Object.prototype.toString.call(params) === '[object Array]') ? params : [params],
		param = null,
		$els = null,
		result = [];

	for (var i = 0; i < paramArr.length; i++ ) {
		param = paramArr[i];

		if(urlParams[param]){
			$els = $(selector).each(function () {
				var $el = $(this),
					prepend = this.search && this.search.length > 0 ? '&' : '?',
					hrefParams = unserialize($el.attr('href')),
					value = newValue || urlParams[param];

				if(!hrefParams[urlParams[param]]){
					$el.attr('href', $el.attr('href') + prepend + param + '=' + value );
				}
			});
			result.push($els)
		}
	}

	return result;
});
/**
 * Tracking for Mobile Campaigns
 * @version 1.0.2
 * @author Fedor Kušš <fedor.kuss@avast.com>
 * @module avast.web.mobileTracking
 * @requires jquery
 * @requires avast.url.unserialize
 */

(function() {
	'use strict';
	var urls =
	['index', 'free-mobile-security', 'free-ios-security', 'lp-ppc-protect-a', 'lp-ppc-protect-b', 'secureline-vpn', 'lp-ppc-secureline-vpn-buy', 'lp-protection', 'protection'],
		pathName = window.avastGlobals.web.fileName;

	if (urls.indexOf(pathName) > -1) {

		var unserializedUrl = avm.require('avast.url.unserialize')(),
			cmpgContent = unserializedUrl.cmpg_for_af;

		if (typeof cmpgContent !== 'undefined' && cmpgContent.length > 0) {

			var detected = avastGlobals.detect;

			if (detected.os.isAndroid || detected.os.isIOS) {
				$('body').addClass('mobile-tracking');
				var mobileTracking = $('.mobile-tracking .bi-download-link');

				mobileTracking.attr('href', 'https://go.onelink.me/gM36?pid=AdWords-Web&c=' + cmpgContent + '&af_web_dp=https%3A%2F%2Fwww.avast.com%2Ffree-mobile-security');

				if (pathName === 'secureline-vpn') {
					mobileTracking.attr('href', 'https://go.onelink.me/KhNk?pid=AdWords-Web&c=' + cmpgContent + '&af_web_dp=https%3A%2F%2Fwww.avast.com%2Fsecureline-vpn');

				}
				if (pathName === 'lp-ppc-secureline-vpn-buy') {
					mobileTracking.attr('href', 'https://go.onelink.me/KhNk?pid=AdWords-Web&c=' + cmpgContent + '&af_web_dp=https%3A%2F%2Fwww.avast.com%2Fsecureline-vpn');
				}
				if (pathName === 'lp-safe-emailing') {
					mobileTracking.attr('href', 'https://avast.sng.link/Dp3jo/4129/jvio');
				}
			}
		}
	}
})();

/**
 * Navigation - global navigation
 * @version 1.4.0
 * @author Michal Langhoffer <langhoffer@avast.com>, Ales Gabriel <gabriel@avast.com>, Jaroslav Slaby <jaroslav.slaby@avast.com>
 * @module avast.web.navigation
 * @requires cash
 * @requires avast.url.unserialize
 * @requires avast.web.mqMarker
 * @return {Function} Emitter constructor
 */

var avast = avast || {};

// Disables language selector
avast.disableLanguageSelector = true;


/**
 * Definiton of modules for 'avast.web.navigation'
 */
avm.define('avast.web.navigation', function(navSel) {
	'use strict';

	// Required modules
	var $ = avm.require('cash'),
		unserialize = avm.require('avast.url.unserialize'),
		setMqMarkers = avm.require('avast.web.mqMarker');

	// --------------------------------- Communal ---------------------------------

	// Universal Selectors
	var $window = $(window),
		$body = $('body'),
		$headerElement = $('header.header'),
		$navElement = $headerElement.find('nav'),
		$navigation = navSel ? $(navSel) : $('.js-navigation'),
		$secondMenuBlogs = document.querySelector('.second-menu.blogs'),
		$langSelector = $('.region-selector'),
		$languageSelectorButtons = $('.js-language-selector-trigger'),
		$languageSelector = $langSelector.find('.region-selector-close');

	// Universal variables
	var firstMenuClasses = getFirstMenuClasses(),
		secondMenuClasses = getSecondMenuClasses(),
		openedThirdMenu,
		thirdMenuLinks = [],
		openedSubMenu,
		languageSelectorTrigger,
		avastGlobalsAvailable = typeof window.avastGlobals !== 'undefined' && typeof window.avastGlobals.web !== 'undefined',
		isDevEnv = avastGlobalsAvailable ? window.avastGlobals.web.domain.split('/').length > 1 : false,
		config = {
			firstMenu: false,
			secondMenu: false
		},
		navInit = {
			desktopNav: false,
			mobileNav: false
		};

	/**
	* Get all 1st menu classes to an array
	*/
	function getFirstMenuClasses() {
		var classes = [];
		var firstMenuItems = document.querySelectorAll('.first-menu .item:not(.blogs)');
		for (var i = 0; i < firstMenuItems.length; i++) {
			var el = firstMenuItems[i];

			var itemData = el.getAttribute('data-first-menu');

			if (itemData) {
				var itemClass = 'first-menu-' + itemData;
				classes.push(itemClass);
			}
		}

		return classes;
	}

	/**
	* Get all 2nd menu classes to an array
	*/
	function getSecondMenuClasses() {
		var classes = [];
		var secondMenuItems = document.querySelectorAll('.second-menu li');

		for (var i = 0; i < secondMenuItems.length; i++) {
			var itemData = secondMenuItems[i].getAttribute('data-second-menu');

			if (itemData) {
				var itemClass = 'second-menu-' + itemData;
				classes.push(itemClass);
			}

		}

		return classes;
	}

	// Determines whether desktop / mobile navigation should be shown
	var mqMobile = window.matchMedia('(max-width: 991.98px)'),
		mqDesktop = window.matchMedia('(min-width: 992px)');

	/**
	* Extracts the value of ':before' class from the 'body' and if the navigation is viewed from desktop, returns 'navigation-desktop', if from mobile, returns 'none'
	*/
	function isDesktop() {
		var mq = window.getComputedStyle ? window.getComputedStyle(document.body, ':before').getPropertyValue('content') : '';
		return mq.indexOf('navigation-desktop') > -1;
	}

	// Set <header> height to fit the content of the <nav>
	function adjustDesktopHeaderHeight() {
		if ($navElement.height() > $headerElement.height() ) {
			$headerElement.css({
				height: $navElement.height().toFixed()
			});
		} else {
			$headerElement.css('height', '');
		}
	}

	// Changes to desktop / mobile navigation on resize
	if (isDesktop()) {
		desktopNav();
		$(window).on('resize', setDesktopNav);
		setMqMarkers('mq-desktop', 'header nav');
	} else {
		mobileNav();
		$(window).on('resize', setMobileNav);
		$(window).on('load', setMobileNav);
		setMqMarkers('mq-mobile', 'header nav');
	}

	// Communal 1st menu

	/**
	* Clears all 1st menu classes
	*/
	function clearFirstMenuClasses() {
		config.firstMenu = false;
		$body.removeClass(firstMenuClasses.join(' '));
	}

	// Communal 2nd menu

	/**
	* Clears all 2nd menu classes
	*/
	function clearSecondMenuClasses() {
		config.secondMenu = false;
		$body.removeClass(secondMenuClasses.join(' '));
	}

	/**
	* Collects all classes of the 2nd menu, composes them together with one space between and adds them to the 'body'
	*/
	function expandSecondLevel() {
		var classes = secondMenuClasses.join(' ');
		config.secondMenu = classes;
		updateNavigation();
	}

	/**
	* Detects, on which 2nd menu item was clicked and adds its class on 'body'
	*/
	function openSecondMenu($element, event) {
		var cachedSecondMenu = config.secondMenu,
			isSecondMenu = typeof $element.data('second-menu') !== "undefined",
			clickedSecondMenu = 'second-menu-' + $element.data('second-menu');

		if (isDesktop()) {

			clearSecondMenuClasses();

		} else {

			if (cachedSecondMenu.split(' ').length > 1 && isSecondMenu) {

				 // If the class is already there, removes it
				 if (cachedSecondMenu.indexOf(clickedSecondMenu) > -1) {
				 config.secondMenu = removeSpaces(cachedSecondMenu.replace(clickedSecondMenu, ''));
				 }

				 // Else adds it
				 else {
					config.secondMenu = removeSpaces(cachedSecondMenu + ' ' + clickedSecondMenu);
				}

				updateNavigation('toggle', clickedSecondMenu);
				return;
			}
		}

		// If the same menu was not clicked, then sets 2nd menu as a current menu
		if (clickedSecondMenu !== cachedSecondMenu && isSecondMenu) {
			config.secondMenu = clickedSecondMenu;
		}

		updateNavigation();
	}

	// Communal Third menu

	/**
	* Collects all the links from element and if they are not hidden, creates an array from them in the 3rd menu
	*/
	function defInnerLinks(parent) {
		var menuLinks = parent.querySelectorAll('a');

		for (var i = 0; i < menuLinks.length; i++) {
			var el = menuLinks[i];

			if (!isHidden(el)) {
				thirdMenuLinks.push(el);
			}
		}

		openedThirdMenu = parent;
	}

	/**
	* Removes 'aria-expanded' attribute and 'isOpen' class from the expanded 3rd menu
	*/
	function removeExpanded() {
		var menuOpened = document.querySelector('[aria-expanded=true]'),
			menuOpenedClass = document.querySelectorAll('.second-menu .isOpen');

		menuOpened !== null ? menuOpened.setAttribute('aria-expanded', false) : '';

		for (var i = 0; i < menuOpenedClass.length; i++) {
			menuOpenedClass[i].classList.remove('isOpen');

		}
	}

	// Communal Regions

	function closeRegionModal() {
		$langSelector.removeClass('active');
		$('body').removeClass('js-language-selector-open');
		$body.removeClass('first-menu-regions');

		closeSubMenus();

		// Sets focus on a Region selector
		if (languageSelectorTrigger) {
			languageSelectorTrigger.focus();
		};
	}

	// Closes the Region selector after clicking on a language
	$languageSelector.on('click', closeRegionModal);

	// Closes the 'blogs-special-menus' after clicking on 'regions' and adds the 'first-menu-regions' class on the 'body'
	$languageSelectorButtons.on('click', function() {
		$body.removeClass('blogs-special-menu');
		languageSelectorTrigger = $(this)[0];

		// Toggles on desktop, because 1st levels are disabled
		$body.addClass('first-menu-regions');
		document.querySelector('.region-selector').setAttribute('aria-expanded', true);
		$langSelector.addClass('active');
		$('body').addClass('js-language-selector-open');
		window.history.pushState({
			avast_regions: true
		}, 'Avast regions', window.location.href);
	});

	window.addEventListener('popstate', closeRegionModal, false);

	/**
	* Closes all the open submenus
	*/
	function closeSubMenus() {
		isDesktop() ? clearSecondMenuClasses() : '';
		removeExpanded();
		$body.removeClass('navigation-search-opened');
		$body.removeClass('js-language-selector-open');
		$body.removeClass('first-menu-regions');
		$body.removeClass('blogs-special-menu');
		$langSelector.removeClass('active');
		openedThirdMenu = null;
	}

	/**
	* Checks, if a menu item is hidden
	*/
	function isHidden(el) {
		while (el) {
			if (el === document) {
				return false;
			}
			var $style = window.getComputedStyle(el, null);
			if (!el) {
				return true;
			} else if (!$style) {
				return true;
			} else if ($style.display === 'none') {
				return true;
			} else if (($style.display === 'block' || $style.display === 'inline-block') && $style.height === '0px' && $style.overflow === 'hidden') {
				return true;
			} else {
				return $style.position === 'fixed' || isHidden(el.parentNode);
			}
		}
	}

	/**
		* Update of navigation
		*/
	function updateNavigation(data, toggleClass) {

		// Resets the navigation to the default state
		if (data === 'reset') {
			$body.removeClass('blogs-special-menu');

			if (!isDesktop()) {
				$body.addClass('navigation-closed');

			} else {
				$body.removeClass('first-menu-regions');
			}

			return;
		}

		// Toggles adding / removing of class (which was input to second parameter) on 'body'
		if (data === 'toggle') {
			$body.toggleClass(toggleClass);
		}

		if (config.firstMenu) {
			$body.addClass(config.firstMenu);
		}

		if (config.secondMenu) {
			$body.addClass(config.secondMenu);
		}

		// Toggles adding / removing of 'blogs-special-menu' class on 'body' on mobile and removes all the classes of 1st menu
		if (data === 'open_blogs_special_menu') {

			if (!isDesktop()) {
				clearFirstMenuClasses();
				$body.toggleClass('blogs-special-menu');
			}

			$body.addClass(config.firstMenu);

		// If no parameter was inputed, remove the class 'blogs-special-menu'
		} else {
			$body.removeClass('blogs-special-menu');
		}
	}

	/**
		* Removes unnecessary spaces between words
		*/
	function removeSpaces(str) {
		var strSplitted = str.split(' '),
			result = [];

		strSplitted.map(function(value) {
			if (value !== '') {
				result.push(value);
			}
		});

		return result.join(' ');
	}

	// --------------------------------- Desktop ---------------------------------

	/**
		* Init if desktop and preselect levels only on www.avast domains
		*/
	function desktopNav() {
		navInit.desktopNav = true;
		preSelectLevels();
		$body.addClass('navigation-for-desktop');

		adjustDesktopHeaderHeight();

		var subcategories = document.querySelectorAll('[data-second-menu] .subcategory'),
			thirdMenuItems = document.querySelectorAll('.third-menu');

		// Desktop 2nd menu

		// Add and remove aria attibute
		for (var i = 0; i < subcategories.length; i++) {
			var item = subcategories[i];

			item.addEventListener('mouseenter', function() {
				item.setAttribute('aria-expanded', true);
			});

			item.addEventListener('mouseleave', function(e) {
				if (!$(document.elementFromPoint(e.clientX, e.clientY)).parents('.third-menu').length > 0) {
					item.setAttribute('aria-expanded', false);
					item.parentElement.classList.remove('isOpen');
				}
			});
		}

		for (var i = 0; i < thirdMenuItems.length; i++) {
			var item = thirdMenuItems[i];

			item.addEventListener('mouseleave', function(e) {
				if (!$(document.elementFromPoint(e.clientX, e.clientY)).parents('[data-second-menu]').length > 0) {
					item.previousElementSibling.setAttribute('aria-expanded', false);
					item.previousElementSibling.parentElement.classList.remove('isOpen');
				}
			});
		}

		// Opens up a menu item by pressing 'enter' key and closes all the open submenus
		$navigation.on('keyup', 'nav.mq-desktop [data-second-menu]', function(key) {
			if (key.which == 13 || key.keyCode == 13) {
				var menuElement = this.querySelector('div.third-menu');
				openedSubMenu = document.activeElement;
				closeSubMenus();
				$(this).children('span.subcategory').attr('aria-expanded', true);
				$(this).addClass('isOpen');
				// openSecondMenu($(this));
				setFocus(menuElement);
				defInnerLinks(menuElement);
			}
		});

		$(document).on('keydown', function(key) {

			// Closes menu by pressing 'esc' key
			if (key.which == 27 || key.keyCode == 27) {
				openedSubMenu !== null && openedSubMenu !== undefined ? openedSubMenu.focus() : '';
				removeExpanded();
				openedSubMenu = null;

				if (typeof openedThirdMenu !== 'undefined' && openedThirdMenu !== null) {
					openedThirdMenu = null;
					thirdMenuLinks = [];
				}

				closeSubMenus();
			}

			// Sets focus on the first element after pressing 'tab' key on the last element
			if (key.which === 9 || key.keyCode === 9) {

				if (typeof openedThirdMenu !== 'undefined' && openedThirdMenu !== null) {
					if ($(document.activeElement)[0].innerHTML === $(thirdMenuLinks.slice(-1))[0].innerHTML) {
						openedThirdMenu.focus();
					}
				}
			}
		});

		// Desktop Blogs menu

		// Opens the 'Blogs menu' while mousehover on the 'Blogs' link
		$navigation.on('mouseenter', 'nav.mq-desktop .js-blogs', function() {
			updateNavigation('open_blogs_special_menu');
			$body.addClass('blogs-special-menu');
			$body.removeClass('first-menu-regions');
			$secondMenuBlogs.setAttribute('aria-expanded', true);
		});

		// Opens up the 'Blogs menu' by pressing 'enter' key and closes all the open submenus
		$navigation.on('keydown', 'nav.mq-desktop .js-blogs', function(key) {
			if (key.which == 13 || key.keyCode == 13) {
				openedSubMenu = document.activeElement;
				closeSubMenus();
				$secondMenuBlogs.setAttribute('aria-expanded', true);
				updateNavigation('open_blogs_special_menu');
				$body.addClass('blogs-special-menu blogs-special-menu-isOpen');
				setFocus($secondMenuBlogs);
				defInnerLinks($secondMenuBlogs);
			}
		});

		// Closes the 'Blogs menu' on mouseleave
		$navigation.on('mouseleave', 'nav.mq-desktop .js-blogs', function(e) {
			if (document.elementFromPoint(e.clientX, e.clientY) === null || !document.elementFromPoint(e.clientX, e.clientY).classList.contains('second-menu', 'blogs')) {
				updateNavigation('reset');
				$secondMenuBlogs.setAttribute('aria-expanded', false);
			}
		});

		// Mouseleave not working preciselly in $cache, it's triggered in the middle of elements height.
		if ($secondMenuBlogs !== undefined && $secondMenuBlogs !== null) {
			$secondMenuBlogs.addEventListener('mouseleave', function(evt) {

				if (evt.target.matches('nav.mq-desktop .second-menu.blogs')) {
					updateNavigation('reset');
					$secondMenuBlogs.setAttribute('aria-expanded', false);
				}

			});
		}

		// Desktop Regions

		// Opens up the 'Region selector' after pressing 'enter' key and closes the 'blogs special menu'
		$languageSelectorButtons.on('keydown', function(key) {
			if (key.which == 13 || key.keyCode == 13) {
				openedSubMenu = document.activeElement;
				languageSelectorTrigger = $(this)[0];

				$body.removeClass('blogs-special-menu blogs-special-menu-isOpen');

				// Toggles on desktop, because 1st levels are disabled
				$body.addClass('first-menu-regions');
				$langSelector.addClass('active');
				$('body').addClass('js-language-selector-open');
				var menuElement = document.querySelector('.region-selector');
				thirdMenuLinks = Array.from(menuElement.querySelectorAll('a'));
				openedThirdMenu = menuElement;
				menuElement.setAttribute('aria-expanded', true);

				// Sets focus on the region selector
				setFocus(menuElement);

				window.history.pushState({
					avast_regions: true
				}, 'Avast regions', window.location.href);
			}
		});
	}

	/**
		* Sets focus on the element
		*/
	function setFocus(element) {
		element.setAttribute('tabIndex', -1);
		setTimeout(function() {
			element.focus();
		}, 300);
	}

	/**
		* Composes an URL address
		*/
	function preSelectLevels() {
		var $navigationSecondMenuLinks = $navigation.find('.second-menu:not(.regions) a'),
			pageNotFound = true,

			// Path and Filename of the current page
			currentPage = window.location.pathname.replace(/-r3$/, ''),

			// Part of an URL after the '?'
			currentPageParams = unserialize(window.location.search),

			// Current locale
			ulocale = '',
			separator;

		if (avastGlobalsAvailable) {

			// Fills up the variable with the locale and File name
			ulocale = window.avastGlobals.web.ulocale.replace('/', '');
			separator = ulocale.length > 0 ? '/' : '';
			currentPage = '/' + ulocale + separator + window.avastGlobals.web.fileName.replace(/-r3$/, '');
		}

		$navigationSecondMenuLinks.each(function() {
			detectLink($(this));
		});

		// If the URL starts with the word 'web', it is a preview link ('web-preview.ff.int.avast.com..')
		if (pageNotFound && (window.location.hostname.substr(0, 3) === 'www' || window.location.hostname.substr(0, 3) === 'web')) {

			// Activates 'For home' menu
			config.firstMenu = 'first-menu-for-home';
			$body.addClass(config.firstMenu);
		}

		// Set press.avast.com and higlight Press center item in the First and 2nd menu
		if (window.location.hostname === 'press.avast.com') {
			var $pressCenter = $('li[data-second-menu=\'press-center\']');

			// Activates 'About us' menu
			config.firstMenu = 'first-menu-about-us';
			$body.addClass(config.firstMenu);
			$pressCenter.addClass('isActive');
		}

		// Sets blog.avast.com and activates Blogs 2nd menu
		if (window.location.hostname === 'blog.avast.com') {
			var $blogSecondMenu = $('div.second-menu.blog'),
				$blogMenu = $('li.js-blogs.blogs');

			// Activates 'Blogs' menu
			config.secondMenu = 'second-menu blog';
			$body.addClass(config.secondMenu);
			$blogSecondMenu.addClass('isActive');
			$blogMenu.addClass('isActive');
		}

		// Activates 'For partners' menu
		if (avastGlobals && avastGlobals.web && /PARTNERS/.test(avastGlobals.web.contentGroup.toUpperCase())) {
			clearFirstMenuClasses();
			config.firstMenu = 'first-menu-for-partners';
			$body.addClass(config.firstMenu);
		}

		// Activates 'For business' menu
		if (avastGlobals && avastGlobals.web && /SMB|BUSINESS/.test(avastGlobals.web.contentGroup.toUpperCase())) {
			clearFirstMenuClasses();
			config.firstMenu = 'first-menu-for-business';
			$body.addClass(config.firstMenu);
		}

		// Activates 'About Us' menu
		if (avastGlobals && avastGlobals.web && /OTHERS/.test(avastGlobals.web.contentGroup.toUpperCase())) {
			clearFirstMenuClasses();
			config.firstMenu = 'first-menu-about-us';
			$body.addClass(config.firstMenu);
		}

		function detectLink($element) {
			if (pageNotFound) {
				var selfHref = $element.attr('href'),
					selfHrefParams = getParamsFromHref(selfHref);

				// If isDevEnv, remove first part && first symbol in link is '/'
				if (isDevEnv && selfHref.split('')[0] === '/') {
					selfHref = '/' + selfHref.split('/').splice(2).join('/');
				}

				// If selfHref contains parameters AND current page pathname is equal to link pathname AND current page contains params
				if (typeof selfHrefParams !== 'undefined' && selfHref.split('?')[0] === currentPage && !$.isEmptyObject(currentPageParams)) {

					// Checks if the current page contains those parameters
					for (var key in selfHrefParams) {

						if (typeof currentPageParams[key] !== 'undefined' && currentPageParams[key] === selfHrefParams[key]) {
							pageNotFound = false;
							detectParent($element);
							return false;
						}
					}
				}

				if (currentPage === selfHref) {
					pageNotFound = false;
					detectParent($element);
					return false;
				}
			}
		}

		/**
		 	* Takes the closest '.second-menu' item, finds out from which 1st menu section comes from ('For home', 'For business'..) and displays relevant menu
		 	*/
		function detectParent($foundLinkElement) {
			var $parent = $foundLinkElement.closest('.second-menu'),
				$parentWithData = $foundLinkElement.closest('[data-second-menu]'),
				parentClasses = $parent.attr('class').split(' '),
				availableClasses = ['for-home', 'for-business', 'for-partners', 'about-us'],
				linkFoundInNavigation = false;

			$(parentClasses).each(function() {
				if (availableClasses.indexOf(this) > -1) {

					// Sets a menu item into a variable
					config.firstMenu = 'first-menu-' + this;
					linkFoundInNavigation = true;

					// Sets aria data attribut to the First level menu
					$('li.' + this + ' a').attr('aria-current', true);

					// current active 2nd menu, if exists
					if ($parentWithData.length > 0) {
						$parentWithData.addClass('isActive');
					}

					// current link in 2nd or 3rd menu
					$foundLinkElement.parent().addClass('isActive');

					return false;
				}
			});

			// If the respective 2nd menu was not found, sets to 'For home' (Adds the class 'first-menu-for-home')
			if (!linkFoundInNavigation) {
				config.firstMenu = 'first-menu-for-home';
			}

			$body.addClass(config.firstMenu);
		}

		/**
		 	* Returns an array of parameters from the URL
		 	*/
		function getParamsFromHref(href) {
			var result;

			result = href.split('#')[0];
			result = href.split('?')[1];

			return typeof result !== 'undefined' ? unserialize(result) : undefined;
		}

	}

	/**
	* setDesktopNav Switch all DOM elements to desktop navigation
	*/
	function setDesktopNav() {
		if (mqDesktop.matches) {
			var body = document.querySelector('body');

			// Sets event listeneres for the desktop navigation
			if (!navInit.desktopNav) {
				desktopNav();
			}

			// Mark interactive elements with correct media query class. Used for proper event delegation
			setMqMarkers('mq-desktop', 'header nav');

			// Rebind resize event for desktop breakpoint
			$(window).off('resize', setDesktopNav);
			$(window).on('resize', setMobileNav);
			$(window).on('resize', adjustDesktopHeaderHeight);

			preSelectLevels();

			// No need to rebind secondMenu handlers, it's already on init and delegated to media query class.
			// Remove first level navigation.
			body.classList.remove.apply(body.classList, firstMenuClasses);

			// Add correct body classes for mobile navigation
			body.classList.add('navigation-for-desktop');

			if (config.firstMenu) {
				body.classList.add(config.firstMenu);

			} else {
				body.classList.add('first-menu-for-home');
			}

			// Remove second level navigation. Dropdowns are hidden on desktop by default.
			body.classList.remove.apply(body.classList, secondMenuClasses);

			// Remove main mobile class and close navigation - sets only mobile state.
			body.classList.remove('navigation-for-mobile',
				'navigation-closed');

			// reset max-height set on mobile navigation (search for $cmpHeaderNavigation__maxHeight)
			$('.header nav').css('max-height', '');

			// Reset 1st menu. Prevent to display multiple first levels if switching from opened mobile navigation.
			config.firstMenu = config.firstMenu || false;

			// Reset 2nd menu. Prevent to display multiple second levels on blogs mouseover after switching from mobile navigation.
			config.secondMenu = config.secondMenu || false;
		}
	}

	// --------------------------------- Mobile ---------------------------------

	/**
	* Init if mobile
	*/
	function mobileNav() {
		var $toggleMenu = $navigation.find('.js-toggle-menu'),
			hintButtons = document.querySelectorAll('[data-cmp-name="cmp-header"] .js-hint');

		navInit.mobileNav = true;
		expandSecondLevel();
		$body.addClass('navigation-for-mobile');
		$body.addClass('navigation-closed');

		// 'Go back' button
		$navigation.on('click', 'nav.mq-mobile .js-back', function() {
			clearFirstMenuClasses();

			if ($(this).hasClass('js-blog')) {
				$body.removeClass('blogs-special-menu');
			}
		});

		// 'Close' button
		$navigation.on('click', '.js-toggle-menu', function() {

			var $windowHeight = $(window).innerHeight(),
				$cmpMessageBar = $('.message-bar'),
				$cmpMessageBar__height = $cmpMessageBar.length !== 0 ? $cmpMessageBar.innerHeight() : 0,	// if Message bar doesn't exists, height will be set to zero
				$cmpHeader = $('.header'),
				$cmpHeaderNavigation = $('nav', $cmpHeader),
				cmpHeaderNavigation__marginBottom = 24, // margin from the bottom edge of the screen; value in pixels
				$cmpHeaderNavigation__maxHeight = $windowHeight - $cmpMessageBar__height - $cmpHeader.innerHeight() - cmpHeaderNavigation__marginBottom;

			if ($body.hasClass('navigation-closed')) {
				$cmpHeaderNavigation.css('max-height', $cmpHeaderNavigation__maxHeight + 'px');
			} else {
				$cmpHeaderNavigation.css('max-height', '');
			}

			$body.toggleClass('navigation-closed');
			$toggleMenu.attr('data-nav-mobile-toggle', $toggleMenu.attr('data-nav-mobile-toggle') === 'open' ? 'closed' : 'open');
		});

		// Closes the menu if clicked elsewhere
		$window.on('click', function(event) {
			var $target = $(event.target);

			// If navigation clicked AND target is not special menu AND target is not Blogs item, then close special menu
			if ($target.closest($navigation).length > 0) {

				if (!isDesktop() && $target.is($navigation)) {
					updateNavigation('reset');
				}

			} else {

				// if cookie bar clicked, region selector button in footer, do not close
				if (!($target.is('.js-cookie-bar, .select-region-button, .select-region-button *') || $target.closest('.js-cookie-bar').length > 0)) {
					updateNavigation('reset');
				}
			}
		});

		// DataLayer push on click
		$navigation.on('click', 'nav.mq-mobile [data-bi-nav]', function() {
			if (typeof window.dataLayer !== 'undefined') {
				window.dataLayer.push({
					event: 'firstMenuClick',
					button: this.getAttribute('data-bi-nav')
				});
			}
		});

		// Mobile 1st menu

		// Redirects to the correct URL after clicking on a 1st menu item (<a> link is not visible on mobile version of the menu)
		$navigation.on('click', 'nav.mq-mobile [data-first-menu]', function() {
			var cachedFirstMenu = config.firstMenu,
				clickedFirstMenu = 'first-menu-' + $(this).data('first-menu');

			if (this.getAttribute('data-first-menu') === 'for-business' && document.querySelector('.second-menu.for-business') === null) {
				window.location.href = this.querySelector('a').getAttribute('href');
			}

			clearFirstMenuClasses();

			if (clickedFirstMenu !== cachedFirstMenu) {
				config.firstMenu = clickedFirstMenu;
			}

			updateNavigation();
		});

		// Mobile 2nd menu

		// Detects, on which 2nd menu item was clicked and adds its class on 'body'
		$navigation.on('click', 'nav.mq-mobile [data-second-menu] span', function(event) {
			var menuItem = $(this).parent('li');
			openSecondMenu(menuItem, event);
		});

		// Toggles opening and closing of submenu in 'Security' mobile menu by adding / removing the class 'show-hint'
		hintButtons.forEach(function(button) {
			button.addEventListener('click', function() {
				button.classList.toggle('hint-open');
			})
		});

		// Mobile Blogs menu

		// Opens 'special menu' after clicking on 'Blogs' menu item
		$navigation.on('click', 'nav.mq-mobile .js-blogs', function() {
			updateNavigation('open_blogs_special_menu');
		});

		// Toggles showing/hiding of login buttons
		$('.header .second-menu .subcategory.account').on('click', function() {
			$('.third-menu.login').toggleClass('isOpen');
			$('.second-menu.for-business .mobile-links-top').toggleClass('isOpen');
		});
	}






	/**
	* Mobile region selector
	*/
	function regionSelector() {
		// Regions dropdowns toggler
		var areas = document.querySelectorAll('div.area');

		areas.forEach(function(e){
			var area = e;
			area.querySelector('.js-regions-toggle').addEventListener('click', function() {
				addOpenClass(area);
			});
		});

		function addOpenClass(item) {
			item.classList.toggle('isOpen');
		}
	}

	regionSelector();






	/**
	* setMobileNav Switch all DOM elements to mobile navigation
	*/
	function setMobileNav() {
		if (mqMobile.matches) {
			var body = document.querySelector('body');

			// Sets event listeners for the mobile navigation
			if (!navInit.mobileNav) {
				mobileNav();
			}

			// Mark interactive elements with correct media query class. Used for proper event delegation
			setMqMarkers('mq-mobile', 'header nav');

			// Rebind resize event for desktop breakpoint
			$(window).off('resize', setMobileNav);
			$(window).on('resize', setDesktopNav);
			$(window).off('resize', adjustDesktopHeaderHeight);

			// remove height previously set by adjustDesktopHeaderHeight()
			$headerElement.css('height', '');

			// Set mobile navigation main class. Close navigation by default.
			// FIXME: IE11 no support for multiple arguments
			body.classList.add('navigation-for-mobile',
				'navigation-closed');

			// Add second level navigation. It is unfolded by default on mobile
			// FIXME: Using default list of second levels include login navigation which should be closed.
			body.classList.add.apply(body.classList, secondMenuClasses);

			// 1st menu is closed by default on mobile
			body.classList.remove('navigation-for-desktop',
				'first-menu-for-home');

			// Reset 1st menu
			config.firstMenu = false;
			// FIXME: Set 2nd ,enu. There is an incorrect assumption in 'openSecondMenu' method, that there will be always some second level cached.
			config.secondMenu = secondMenuClasses.join(' ');
		}
	}

	return {};
});

var cookieStorage = avm.require('avast.storage.cookieStorage'),
    getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    },
    getExpirationTime = function (hours) {
        var now = new Date();
        now.setTime(now.getTime() + hours * 3600 * 1000);
        return now.toUTCString();
    };

if (getUrlParameter('gclsrc') && getUrlParameter('gclid')) {
    var domainName = window.location.hostname.substring(3);
    cookieStorage.setItem('gclid-avast', getUrlParameter('gclid'), getExpirationTime(24), '/', domainName, false);
}
/**
 * Shared cookie - Avast locale
 * @module avast.web.sharedCookieAvastLocale
 * @version 1.1.0
 * @author Michal Langhoffer <langhoffer@avast.com>
 * @requires avast.storage.cookieStorage
 */
avm.define('avast.web.sharedCookieAvastLocale', (function() {
	'use strict';
	var cookieStorage = avm.require('avast.storage.cookieStorage'),
		cookieName = 'apex__avastLocale',
		locale = '';

	cookieStorage.removeItem(cookieName);

	if (typeof window.avastGlobals !== 'undefined' && typeof window.avastGlobals.web !== 'undefined' && typeof window.avastGlobals.web.locale !== 'undefined' && window.avastGlobals.web.locale.length > 0) {
		locale = window.avastGlobals.web.locale;
		cookieStorage.setItem(cookieName, locale, undefined, '/', '.avast.com');
	}

	return false;
})());

/**
 * Tables
 * @version 1.0.0
 * @author Čeněk Hybler <cenek.hybler@gendigital.com>
 * @requires avast.web.waypoints
 */
(function() {
	'use strict';

	try {
		var
			waypoints = avm.require('avast.web.waypoints'),
			tables = document.querySelectorAll(".table"); // tables elements on page

		if (tables) {

			// ----------------------------------------------------------------
			// Tables with Influencer dropdown has Select element which should update the table content and priceboxes within it
			// ----------------------------------------------------------------
			var influencerChanged = function(table, select){
				// Set attribute on selected option
				for(var o = 0; o < select.options.length; o++) {
					if (select.selectedIndex == o) {
						select.options[o].setAttribute('selected','');
					} else {
						select.options[o].removeAttribute('selected');
					}
				}
				// Get selected option value
				var selectedOption = select.options[select.selectedIndex].value;

				// Update classes
				var options = select.querySelectorAll('option');
				options.forEach(function(option){
					var
						cells = table.querySelectorAll(".content-tr .cell." + option.value),
						subNames = table.querySelectorAll(".table-header-tr .header-subname." + option.value);

					if (option.selected) {
						cells.forEach(function(cell){
							if (cell.classList.contains(option.value)) {
								cell.classList.add(cell.dataset.influencerBgColor); // add the bg color
								cell.querySelector('.icon').classList.replace('icon-cross-table', 'icon-check-table'); // change icon
							}
						});
						subNames.forEach(function(subName){
							if (subName.classList.contains(option.value)) {
								subName.classList.remove('hidden'); // hide Header Subnames
							}
						});

					} else {
						cells.forEach(function(cell){
							if (cell.classList.contains(option.value) && !cell.classList.contains(selectedOption)) {
								cell.classList.remove(cell.dataset.influencerBgColor); // remove the bg color
								cell.querySelector('.icon').classList.replace('icon-check-table', 'icon-cross-table'); // change icon
							}
						});
						subNames.forEach(function(subName){
							if (subName.classList.contains(option.value) && !subName.classList.contains(selectedOption)) {
								subName.classList.add('hidden'); // show Header Subname
							}
						});
					}
				});
			};
			
			// #1 - Table content update by influencer ----------------------------
			tables.forEach(function(table){
				if (table.classList.contains('with-influencer')) {
					var influencers = table.querySelectorAll(".influencer"); // search for Influencers
				
					influencers.forEach(function(influencer){
						var select = influencer.querySelector("select"); // search for options
			
						//console.log("#000: init content update");
						influencerChanged(table, select);
			
						// watch for select change
						influencer.addEventListener("change", function(e) {
							//console.log("#1: 'change' listener triggered on INFLUENCER (content update)");
			
							influencerChanged(table, select);
						});
					});
				}
			});

			// #2 - Table content update by Pricebox -----------------------------
			window.addEventListener("pricebox-updated", function(e){
				if (e.detail.forInfluencer) {
					var
						affectedSetIndex = e.detail.setIndex + 1,
						selectedOptionIndex = e.detail.optionIndex,
						parentTable = e.detail.element.closest('.table'); // closestParent
			
					// Checks whether the table where this event pricebox is placed also has influencer
					if (parentTable && parentTable.classList.contains('with-influencer')) {
						//console.log("#4a: 'pricebox-updated' listener triggered in the Infl table (content update)");
						
						// Lookup the Influencer which is relevant to triggered pricebox (same column)
						var
							cells = parentTable.querySelectorAll(".table-header-tr .cell"),
							influencer = false,
							influencerCell = 0; // in which column is the influencer

						for(var i = 0; i < cells.length; i++) {
							var thisInfluencer = cells[i].querySelector('.influencer');
							
							if (thisInfluencer) {
								influencer = thisInfluencer ? thisInfluencer : null;
								influencerCell = i + 1;
							}
						}

						if (influencerCell == affectedSetIndex) {
							// select option in influencer accordingly to option in pricebox
							var options = influencer.querySelectorAll('option');

							for(var i = 0; i < options.length; i++) {
								if (i == selectedOptionIndex) {
									options[i].selected = true;
									//console.log("#5a: Influencer updated by selection of proper item");
									//console.log("#5b: Content update call to", i);
									influencerChanged(parentTable, influencer.querySelector('select'));
								}
							}
						}
					}
				} else {
					//console.log("#4b: No need to update influencer.\n\n");
				}
			});


			// ----------------------------------------------------------------
			// Table headlines (first cell in the .table-header-tr) should be under specific resolution
			// hidden (not part of the sticky header) and should be visible in its own non-sticky row.
			// ----------------------------------------------------------------
			tables.forEach(function(table){
				if (table.classList.contains('sticky')) {
					window.addEventListener('scroll', function() {
						var headerRow = table.querySelector('.table-header-tr.full'); // sticky header element
						var headlineElHeight = table.querySelector('.row-header').getBoundingClientRect().height; // headline element

						if (headerRow) {
							var stickedHeader = waypoints(headerRow, 0, null, true) && waypoints(table);
	
							if (stickedHeader && window.matchMedia("(max-width: 992px)").matches) {
								headerRow.style["top"] = -headlineElHeight + "px";
							} else {
								headerRow.style["top"] = 0;
							}
						}
					});
				}
			});
		}


	} catch (error) {
		// singe data layer error tracking
		if (typeof sdl !== 'undefined') {
			console.error(error);
			sdl.push({
				system: {
					error: {
						type: error.name,
						message: error.message,
					}
				},
				event: 'system.error'
			});
		}
	}

})();

/**
 * Decorate Buy Links with Campaign Marker if Present in URL
 * @version 1.0.0
 * @author Fedor Kušš <fedor.kuss@avast.com>
 * @module avast.web.mobileTracking
 * @requires jquery
 * @requires avast.storage.cookieStorage
 * @requires avast.url.unserialize
 */

avm.define('avast.web.campaignMarkerDecorator', $(document).ready(function() {
	'use strict';
	var cookieStorage = avm.require('avast.storage.cookieStorage'),
		$cartLink = $('.bi-cart-link'),
		unserializedUrl = avm.require('avast.url.unserialize')(window.location.href),
		cmpgMarker = unserializedUrl.campaignMarker,
		CMPGNMARKER = 'campaignMarker',

		getExpirationTime = function(minutes) {
			var now = new Date();
			now.setTime(now.getTime() + minutes * 60 * 1000);
			return now.toUTCString();
		};

	if (cmpgMarker && cmpgMarker.length > 0) {
		cookieStorage.setItem('campaignMarker', cmpgMarker, getExpirationTime(30), '/', location.hostname, false);
	}

	$cartLink.on('click', function() {
		if (cookieStorage.getItem('campaignMarker') && cookieStorage.getItem('campaignMarker').length > 0)	{

			var link = $(this).attr('href'),
				isCampaignMarker = link.indexOf(CMPGNMARKER),
				updatedLink = [],
				campainMarker = cookieStorage.getItem(CMPGNMARKER);

			// if cartlink parameters in query param (avast)
			// else cartlink parameters in link (avast,avg)
			if (link.indexOf('?') >= 0) {
				var linkVariables1 = link.split('&');

				linkVariables1.forEach(function(item) {
					var params = item.split('=');
					if (params[0] === 'CampaignMarker') {
						updatedLink.push(params[0] + '=' + params[1] + '-' + campainMarker);
					} else {
						updatedLink.push(item);
					}
				});
				$(this).attr('href', updatedLink.join('&'));
			} else {
				var linkVariables = link.split('/');

				linkVariables.forEach(function(item) {
					var params = item.split('.');

					if (params[0] === CMPGNMARKER) {
						updatedLink.push(params[0] + '.' + params[1] + '-' + campainMarker);
					} else {
						updatedLink.push(item);
					}
					if (params[0] === 'Currency' && isCampaignMarker === -1) {
						updatedLink.push(CMPGNMARKER + '.' + campainMarker);
					}
				});

				$(this).attr('href', updatedLink.join('/'));
			}
		}
	});
}));

/**
 * Avast CampaignMarker (decorate cart links and update data attributes)
 * @version 0.0.5
 * @author Ales Gabriel, Jaroslav Slaby <gabriel@avast.com> <jaroslav.slaby@avast.com>
 * @module avast.web.campaignMarkerCookie
 * @requires module:avast.storage.cookieStorage
 * @copyright Avast Software s.r.o &copy;2020
 */

avm.define('avast.web.campaignMarkerCookie', function() {

	var cookieStorage = avm.require('avast.storage.cookieStorage');

	var cm = {
		cookie: '__trSrc',
		SMBCookeValue: cookieStorage.getItem('__smbChannelSrc'),
		els: document.querySelectorAll('a[data-campaign-marker]'),
		getCampaignMarkerCookie: function() {
				var result;

					// check if CM is set in avastGlobals
					if (avastGlobals.web.campaignMarker !== undefined && avastGlobals.web.campaignMarker !== null) {
						result = avastGlobals.web.campaignMarker;
					} else {
						var cookieValue = cookieStorage.getItem('__trSrc');

						if (cookieValue && encodeURIComponent) {
							cookieValue = encodeURIComponent(cookieValue);
							result = cookieValue;
							avastGlobals.web.campaignMarker = cookieValue;
						}
					}

				return result;
		},
		replaceCookieString: function(str, cookie) {
			var re = /~trSrcCookieValue/;

			return str.replace(re, '~' + cookie);
		},
		decorateCartLink: function(data) {
			var href,
				el = data.currentTarget,
				cookieValue = cm.getCampaignMarkerCookie() || '';
			if (el) {
				el.href = cm.replaceCookieString(el.href, cookieValue);

				href = el.href;
			}

			return href;
		},
		updateDataAttr: function(data) {
			var campaignMarker,
				el = data.currentTarget,
				cookieValue = cm.getCampaignMarkerCookie() || '';

			if (el.dataset && el.dataset.campaignMarker) {
				el.dataset.campaignMarker = cm.replaceCookieString(el.dataset.campaignMarker, cookieValue);

				campaignMarker = el.dataset.campaignMarker;
			}

			return campaignMarker;
		},

		/**
		 *
		 * @param {HTMLElement|NodeList} els List of elements
		 */

		setCampaignMarkerCookie: function(els) {
			var nodeList = els || cm.els,
				nodes = els instanceof HTMLElement ? [els] : Array.prototype.slice.call(nodeList),
				cookieValue = cm.getCampaignMarkerCookie(cm.cookie),
				SMBCookeValue = cm.SMBCookeValue,
				SMBRegExp = /smbChannelSrcCookieValue-/,
				links = [];

			if (cookieValue) {
				nodes.forEach(function(el) {
					var result = {
						el: el
					};

					result.link = cm.decorateCartLink({
						currentTarget: el
					});
					result.dataAttr = cm.updateDataAttr({
						currentTarget: el
					});

					links.push(result);
				});
			} else {
				// Register mousedown event.
				// FIXME: Move to scanner on DOM ready.
				nodes.forEach(function(el) {
					el.addEventListener('mousedown', cm.decorateCartLink);
					el.addEventListener('mousedown', cm.updateDataAttr);
					el.addEventListener('focus', cm.decorateCartLink);
					el.addEventListener('focus', cm.updateDataAttr);

					links.push({
						el: el,
						evt: 'mousedown',
						callback: cm.decorateCartLink
					});
					links.push({
						el: el,
						evt: 'mousedown',
						callback: cm.updateDataAttr
					});
				});
			}

			nodes.forEach(function(el) {
				if (el.href.match(SMBRegExp) || el.getAttribute('data-campaign-marker').match(SMBRegExp)) {
					if (cm.SMBCookeValue !== null) {
						var cookieValue = cm.SMBCookeValue.slice(-1) === '-' ? cm.SMBCookeValue : cm.SMBCookeValue + '-';
						el.href = el.href.replace(SMBRegExp, cookieValue);
						el.dataset.campaignMarker = el.dataset.campaignMarker.replace(SMBRegExp, cookieValue);
					} else {
						el.href = el.href.replace(SMBRegExp, '');
						el.dataset.campaignMarker = el.dataset.campaignMarker.replace(SMBRegExp, '');
					}
				}
			})

			return links;
		}
	};

	return cm;

});

/**
 * Avast cartTrackingConsent (decorate cart links with query parram based on OptanonConsent cookie)
 * event delegation is used to capture all added buttons after the page load. In case of any performance issue it is possible to reconsider.
 * @version 3.0.1a
 * @author Erik Ondrus <erik.ondrus@avast.com>, Fedor Kušš <fedor.kuss@gendigital.com>, Frankie Rapčák <Frantisek.Rapcak@gendigital.com>
 * @module avast.web.cartTrackingConsent
 * @requires module:avast.storage.cookieStorage
 * @requires avast.web.linkDecorator
 * @copyright Avast Software s.r.o &copy;2021
 */

avm.define('avast.web.cartTrackingConsent', function() {

	if (cheq.devMode) console.info('avast.web.cartTrackingConsent –––– 3.0.1a');

	var cookieStorage = avm.require('avast.storage.cookieStorage'),
		linkDecorator = avm.require('avast.web.linkDecorator'),
		unserialize = avm.require && avm.require('avast.url.unserialize'),
		params = unserialize ? unserialize(window.location.href) : {};

	var cts = {
		COOKIE_NAME: 'OptanonConsent',
		COOKIE_REGEX_MATCH_GROUP: /groups=(.*?)(?=&|$)/i,
		PARAM_NAME: 'trackingDisabled',
		TARGET_EL: '[data-role="cart-link"]',
		TARGET_MATCH_ELS: '[data-role="cart-link"], [data-role="cart-link"] *',
		contentEl: document.getElementById('main-content'),

		//
		//	🟪 Get Cookie consent from CHEQ JS API
		//
		getCookieConsentStatus__CHEQ: function() {
			if (cheq.devMode) console.info('🟪 CHEQ –––– cartTrackingConsent.cts.getCookieConsentStatus__CHEQ');

			var cheqCookieConsent = "marketing:0,performance:0,preference:0";

			// Default values = all cookies are disabled ( = user didn't allowed cookie)
			var cheqCookieCategoryStatus__marketing = 0;
			var cheqCookieCategoryStatus__performance = 0;
			var cheqCookieCategoryStatus__preference = 0;

			//
			//	Get current Cookie Consent status
			//
			if( Bootstrapper && Bootstrapper.gateway && typeof Bootstrapper.gateway.getConsentStatus === 'function' ) {
				cheqCookieCategoryStatus__marketing = Bootstrapper.gateway.getConsentStatus('Advertising').categoryEnabled ? 1 : 0;
				cheqCookieCategoryStatus__performance = Bootstrapper.gateway.getConsentStatus('Performance').categoryEnabled ? 1 : 0;
				cheqCookieCategoryStatus__preference = Bootstrapper.gateway.getConsentStatus('Preference').categoryEnabled ? 1 : 0;

				//
				//	Update URL parameter (CHEQ)
				//
				cheqCookieConsent = "marketing:" + cheqCookieCategoryStatus__marketing + ",performance:" + cheqCookieCategoryStatus__performance + ",preference:" + cheqCookieCategoryStatus__preference;
			}
			return cheqCookieConsent;
		},

		decorateCartLink: function(event) {
			var el = event.target;

			if (el.matches(cts.TARGET_MATCH_ELS)) {
				if (!el.href) {
					el = el.closest(cts.TARGET_EL);
				}

				//
				//	1. Define variables for storing Cookie consent
				//
				var cookieConsent__CHEQ = cts.getCookieConsentStatus__CHEQ();	// 🟪 CHEQ – Get Consent status from CHEQ JS API
				var cookieConsent = undefined;		
											// Final Cookie consent status to be passed to the Link Decorator
				//
				//	3. Store Cookie consent –––– Variant B: 🟪 CHEQ only
				//
				// Store the Consent
				cookieConsent = cookieConsent__CHEQ;	// EXAMPLE result: &trackingDisabled=marketing:1,performance:1,preference:1

				// DEV only – Check what consent will be attached on the "Buy now" buttons; To see the console.log, add    &cheqDevMode=true   to the URL
				if (cheq.devMode) {
					console.info('3. Store Cookie consent –––– Variant B: 🟪 CHEQ only');
					console.info('&trackingDisabled=' + cookieConsent);
				}

				//
				// 4. Add Cookie consent to the URL using parameters (&trackingDisabled=...)
				//
				if ('URLSearchParams' in window) {
					url = new URL(el.href);
					queryString = new URLSearchParams(url.search);
					queryString.set(cts.PARAM_NAME, cookieConsent);
					url.search = queryString.toString();
					el.href = url.toString();

					//
					// DEV Only ––– Inspect link URL
					//
					if (cheq.devMode) {

						var cheqBuyLink = el.href;
						var cheqBuyLinkDecorator = '';
						var match = cheqBuyLink.match(/([?&])trackingDisabled=[^&]+/);	// Get "trackingDisabled" parameter from the URL

						if (match) {
							cheqBuyLinkDecorator = match[0].replace(/^[?&]/, ''); // remove leading ? or &
							cheqBuyLinkDecorator = decodeURIComponent(cheqBuyLinkDecorator);	// Decode encoded URL parameter ("trackingDisabled=marketing%3A1%2Cperformance%3A1%2Cpreference%3A1" –––> "trackingDisabled=marketing:1,performance:1,preference:1")
						}

						console.group('cartTrackingConsent.js –––– Inspect the "trackingDisabled" URL parameter');
							console.info(cheqBuyLinkDecorator);
						console.groupEnd();
					}
				}
				//
				//	4. Fallback for very old browsers –––– IE 11 and below, Edge 15 & 16, Older Android WebView (< 49), Old Safari (< 10.3)
				//
				else {
					var regex = new RegExp('(&?)' + cts.PARAM_NAME + '=(.*?)(?=&|$)', 'gi');
					el.href = el.href.replace(regex, '');
					linkDecorator(el, cts.PARAM_NAME, cts.PARAM_NAME + '=null', encodeURIComponent(cookieConsent));
				}
			}
		},

		setCartTrackingConsent: function() {
			if (cts.contentEl) {
				cts.contentEl.addEventListener('focusin', cts.decorateCartLink);
				cts.contentEl.addEventListener('mousedown', cts.decorateCartLink);
			}
		}
	};

	return cts;
});

/**
 * Cookie Consent - perform cookie consent
 * @module avast.web.cookieConsent
 * @version 1.0.1
 * @author Michal Langhoffer
 * @requires jquery
 * @requires avast.storage.cookieStorage
 */

avm.define('avast.web.cookieConsent', function() {
    'use strict';
    var $ = avm.require('jquery'),
        cookieStorage = avm.require('avast.storage.cookieStorage'),
        cookieName = 'consentAccepted',
        domainName = window.location.hostname.substring(3);

    $(document).ready(function() {
        var CookieBar = {},
            $footer = $('#footer'),
            footerInitialPadding = $footer.css('padding-bottom'),
            footerInitialMargin = $footer.css('margin-bottom'),
            mediaQuery = function() {
                var screen = (window.getComputedStyle) ? window.getComputedStyle(document.body, ':after').getPropertyValue('content') : '';
                return screen;
            },
            mobileScreen = (mediaQuery() === '\'mobile\'' || mediaQuery() === "\"mobile\"" || mediaQuery() === "mobile") ? true : false;

        CookieBar.cookieDom = $('.js-cookie-bar');
        CookieBar.cookieCloseDom = $('.js-cookie-bar .js-close');

        /**
         * @description Close the cookie-bar by removing it from the DOM, and saving this preference to the local storage
         */
        CookieBar.close = function() {
            var today = new Date(),
                expire = new Date();

            expire.setTime(today.getTime() + 3600000 * 24 * 14); // 14 days

            try {
                cookieStorage.setItem(cookieName, 'true', expire.toGMTString(), '/', domainName);
                dataLayer.push({
                    'event': 'cookie-bar-consent-granted'
                });
            } catch (error) {
                console.log('Unable to store preference in local storage, cookiebar will show upon next visit', error);
            }

            CookieBar.cookieDom.remove();

            if (mobileScreen) {
                $footer.css('padding-bottom', footerInitialPadding);
            } else {
                $footer.css('margin-bottom', footerInitialMargin);
            }
        };

        /**
         * @description Initialise the CookieBar component, by binding all the event handlers
         */
        CookieBar.initialise = function() {
            // Cookiebar will be visible either when the key doesn't exist (getItem returns null) or returns another value than "true"
            if (cookieStorage.getItem(cookieName) !== 'true') {
                CookieBar.cookieDom.addClass('visible');

                CookieBar.cookieDom.on('transitionend webkitTransitionEnd oTransitionEnd', function(event) {
                    if (mobileScreen) {
                        $footer.css('padding-bottom', CookieBar.cookieDom.height() + 'px');
                    } else {
                        $footer.css('margin-bottom', CookieBar.cookieDom.height() + 'px');
                    }
                });
                dataLayer.push({
                    'event': 'cookie-bar-displayed'
                });
                CookieBar.cookieCloseDom.on('click', CookieBar.close);
            } else {
                CookieBar.cookieDom.remove();
                if (mobileScreen) {
                    $footer.css('padding-bottom', footerInitialPadding);
                }
            }
        };

        CookieBar.initialise();
    });
});

/**
 * Avast Config Module
 * @version 0.14.0
 * @module avast.web.config
 * @author Ales Gabriel <gabriel@avast.com>
 * @requires module:cash
 * @requires module:avast.web.appendPbld
 * @requires module:avast.web.aswparam
 * @requires module:avast.web.cj
 * @requires module:avast.web.couponCode
 * @requires module:avast.web.setLanguage
 * @requires module:avast.web.chromeBanner
 * @requires module:avast.web.tracker
 * @requires module:avast.web.cookieConsent
 * @requires module:avast.web.navigationRef
 * @requires module:avast.web.campaignMarkerCookie
 * @requires module:avast.web.cartTrackingConsent
 * @copyright AVAST Software s.r.o.
 */

avm.define('avast.web.config', (function() {
	'use strict';

	var $ = avm.require('cash');

	// Prevent log errors on browsers without console.
	if (!window.console) {
		window.console = {
			log: function() {}
		};
	}

	// Config environment
	var config = {
		options: {},

		/**
		 * Basic setup - init modules + legacy
		 */
		init: function() {
			var opts = window.avastGlobals ? window.avastGlobals.web || {} : {};
			var legacy = this.legacySettings(opts);
			var boot = this.boot;

			/**
			 * Global namespace options
			 */
			this.options = opts;

			/*
			 * Support former avast config settings in global namespace
			 */
			this.exportLegacy(legacy, window);

			/**
			 * Global modules
			 *
			 * @description Boot global modules. First param of boot function is a module name.
			 * Second is init function. Module is passed os parameter.
			 */

			// Init legacy free modules
			avm.require('avast.web.tracker');

			/*
			 *
			 * !!! COMMENTS WITH avm.require STATEMENT BEFORE EACH boot ARE MANDATORY !!!
			 * CORRECT ORDER DURING CONCAT IS NOT GUARANTED WITHOUT THAT.
			 *
			 */

			$(document).ready(function() {
				var disabledModules = avastGlobals.disabledModules || [];

				// avm.require('avast.web.navigation') - Navigation
				boot('avast.web.navigation', function(module) {
					var navSel = '.js-navigation-bootstrap';
					if (document.querySelector(navSel)) {
						module(navSel);
					}
				});

				// avm.require('avast.web.appendPbld') -  Add p_bld param to cart links
				boot('avast.web.appendPbld', function(module) {
					if (!avast.disableAppendPbld) {
						module.init();
					}
				});

				// avm.require('avast.web.aswparam') - Pack and add ASWPARAM to cart links
				boot('avast.web.aswparam', function(module) {
					if (!avast.disableAswparam) {
						module.init();
					}
				});

				// avm.require('avast.web.cj') - Set CJ cookie
				boot('avast.web.cj', function(module) {
					if (!avast.disableCj) {
						module.init();
					}
				});

				// avm.require('avast.web.couponCode') - Add couponcode param to cart links
				boot('avast.web.couponCode', function(module) {
					if (!avast.disableShowCouponCode) {
						module.init();
					}
				});

				// avm.require('avast.web.chromeBanner') - Chrome banner visibility and tracking
				boot('avast.web.chromeBanner', function(module) {
					module.init();
				});

				// avm.require('avast.web.setLanguage') - Chrome banner visibility and tracking
				boot('avast.web.setLanguage', function(module) {
					if (!avast.disableSetLanguage) {
						module(opts.locale || '');
					}
				});

				// avm.require('avast.web.cookieConsent') - Cookie consent bar
				boot('avast.web.cookieConsent', function(module) {
					if (!avast.disableCookieConsent) {
						module();
					}
				});

				// avm.require('avast.web.campaignMarkerCookie') - Cookie consent bar
				boot('avast.web.campaignMarkerCookie', function(module) {
					var cm = module();
					cm.setCampaignMarkerCookie();
				});

				// avm.require('avast.web.downloadPopup') - Set download popup
				boot('avast.web.downloadPopup', function(module) {
					if (!/\/business\/|download-thank-you.php/.test(location.pathname) && avastGlobals.web.contentGroup !== 'Business') {
						module.init();
					}
				});

				// avm.require('avast.web.cartTrackingConsent') - Cookie consent bar
				boot('avast.web.cartTrackingConsent', function(module) {
					var cts = module();
					cts.setCartTrackingConsent();
				});

				boot('avast.web.structuredData', function(module) {
					module();
				});

				// AOS.init({
				// 	offset: 100,
				// 	duration: 250,
				// 	easing: 'ease-out-quart',
				// 	delay: 0,
				// 	once: true
				// });

			});

			// tracking client.js
			try {
				if (typeof avastGlobals !== 'undefined' && avastGlobals.hasOwnProperty('client')) {
					dataLayer.push({
						event: 'av.genericEvent',
						eventCategory: 'product installed',
						eventAction: avastGlobals.client.product_list[0].product,
						eventLabel: '',
					})
				} else {
					window.addEventListener('clientLoaded', function() {
						dataLayer.push({
							event: 'av.genericEvent',
							eventCategory: 'product installed',
							eventAction: avastGlobals.client.product_list[0].product,
							eventLabel: '',
						})
					}, {once: true})
				}
			} catch (e) {

			}

		},

		/**
		 * Invoke global modules
		 * @param  {string}   moduleName    Module name
		 * @param  {Function} fn            Init function
		 * @returns {*}                    Module instance. Object is prefered
		 */
		boot: function(moduleName, fn) {
			var config = this;
			var req = avm.require;
			var module = moduleName ? req(moduleName, false) : null;

			try {
				fn.call(config, module);
			} catch (e) {
				return false;
			} finally {
				return module;
			}
		},

		/**
		 * legacySettings Config settings in global namespace
		 * @param  {Object} opts Settings options
		 * @returns {Object}      Object equals former global namespace settings
		 */
		legacySettings: function(opts) {
			var detect = avastGlobals.detect;

			if (opts) {
				return {
					locale: opts.locale,
					RootPath: opts.RootPath,
					avast: {
						locale: opts.locale,
						numberDecimalSeparator: opts.numberDecimalSeparator,
						numberThousandSeparator: opts.numberThousandSeparator,
						responsive: opts.responsive,
						rootPath: opts.RootPath,
						options: {
							locale: opts.locale,
							rootPath: opts.RootPath
						},
						getOS: function() {
							return detect.os.name;

						},
						getWinVersion: function() {
							return detect.os.version;

						}
					}
				};
			}
		},

		/**
		 * Extend global namespace with avast variables
		 * @param  {Object} src    Object to be merged
		 * @param  {Object} target Object to be extended
		 * @returns {string}        Not merged variables
		 */
		exportLegacy: function(src, target) {
			var skipped;

			for (var key in src) {
				if (Object.prototype.toString.call(src[key]) !== '[object Object]' && src[key] !== null) {
					if (!(key in target)) {
						target[key] = src[key];
					} else {
						skipped = !skipped ? key : skipped + ', ' + key;
					}
				} else {
					target[key] = target[key] || {};
					this.exportLegacy(src[key], target[key]);
				}
			}

			// todo: log skipped
			// console.log('settings: %o', target);
			return target;
		},

		/**
		 * Get current config options
		 * @returns {Object} Config options
		 */
		getConfig: function() {
			return this.options;
		}
	};

	// Run config
	config.init();

	return config;
})());
